import { trackById, trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Inject, Injector, OnDestroy, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { getEnumLookup } from 'src/app/_helpers/enum-helper';
import { SampleCategoryEnum } from 'src/app/enums/sampleCategory.enum';
import { SampleTypeEnum, getSelectableSampleTypes } from 'src/app/enums/sampleType.enum';
import { Sample, PpeAssignmentPayload } from 'src/app/models/sample.model';
import { FLYOUT_DATA } from 'src/app/shared/flyout/flyout-container/flyout-data.token';
import { FlyoutClosable } from 'src/app/shared/flyout/flyout-container/flyout-closable.interface';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirmDialog/confirmDialog.component';
import { ColumnSpan } from 'src/app/shared/form/columnSpan.model';
import nameOf from 'src/app/shared/form/nameOf.helper';
import {
  buildEmployeeOptionConfig,
  EMPLOYEE_BASE_LABEL_MAP,
} from 'src/app/shared/form/employee-field-helpers';
import { isCustomFieldKey } from 'src/app/shared/form/custom-field-helpers';
import { applyFieldConfigDefaults } from 'src/app/shared/form/field-config-defaults.helper';
import { StepConfig, StepperButton, StepperConfig } from 'src/app/shared/stepper/stepper.model';
import { FormComponent } from "src/app/shared/form/form.component";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SensorService } from "src/app/services/sensor.service";
import { CustomEntityService } from "src/app/services/customEntity.service";
import { EMPTY, firstValueFrom, forkJoin, Observable, of, Subject } from "rxjs";
import { filter, finalize, map, switchMap, takeUntil, tap } from "rxjs/operators";
import { GroupLookup, Lookup } from "src/app/models/lookup.model";
import { DateTimeFormField, NumberFormField, SingleSelectionFormField, TextFormField, TimeFormField, FormField, MultiSelectionFormField, LabelFormField, RadioFormField, TextAreaFormField, FileAttachmentsField, HierarchicalSelectionFormField, CheckboxFormField } from "src/app/shared/form/formField.model";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { SegService } from "src/app/services/seg.service";
import { ValueConversionService } from "src/app/services/value-conversion.service";
import { SampleService } from "src/app/services/sample.service";
import { SampleSurveyService } from "src/app/services/sample-survey.service";
import { AgentService } from "src/app/services/agent.service";
import { EventService } from "src/app/services/event.service";
import { EventKeys } from "src/app/shared/constants/eventKeys.constants";
import { AuthService } from "src/app/services";
import { UnsampledTimeCorrectionType } from "src/app/enums/unsampledTimeCorrectionType.enum";
import { CustomObjectService } from "src/app/services/customObject.service";
import { ExposureTypicality } from "src/app/enums/exposureTypicality.enum";
import { CustomField } from "src/app/models/customField.model";
import { AgentGroupService } from "src/app/services/agentGroup.service";
import { SamplingEquipmentService } from "src/app/services/sampling-equipment.service";
import { CalibrationEquipmentService } from "src/app/services/calibration-equipment.service";
import { SampleShiftCoverage } from "src/app/enums/sampleShiftType.enum";
import { WeatherConditionType } from "src/app/enums/weatherConditionType.enum";
import { commonIsVisible, DEFAULT_SAMPLE_END_TIME, filterLinkedToMySiteOptions, isDifferentCalendarDay, isVisibleExcept, isVisibleOnly, LINKED_TO_MY_SITE_FIELD, SampleCondition, sortBlankSamplesDescending, SampleTypeCategoryCombos } from "src/app/_helpers/sample-helper";
import { NoiseSpeedType } from "src/app/enums/noiseSpeedType.enum";
import { AttachmentsDialogComponent } from "../attachments-dialog/attachments-dialog.component";
import { AssetTypeEnum } from "src/app/enums/assetType.enum";
import { AgentJurisdictionService } from "src/app/services/agent-jurisdiction.service";
import { SampleMediaService } from "src/app/services/sample-media.service";
import { UserService } from "src/app/services/user.service";
import { HttpHeaders } from "@angular/common/http";
import { CustomEntity } from "src/app/models/customEntity.model";
import { FileAttachment } from "src/app/models/fileAttachment.model";
import { PpeService } from "src/app/services/ppe.service";
import { SampleStatusEnum, getFilteredSampleStatuses, getStatusBadgeClass } from 'src/app/enums/sampleStatus.enum';
import { SEG } from 'src/app/models/seg.model';
import { Agent } from 'src/app/models/agent.model';
import { AgentGroup } from 'src/app/models/agentGroup.model';
import { Jurisdiction } from 'src/app/models/Jurisdiction.model';
import { JurisdictionLookup } from 'src/app/models/jurisdictionLookup.model';
import { OrgLevelTypeEnum } from 'src/app/enums/orgLevelType.enum';
import { OrganizationLevel } from 'src/app/models/organizationLevel.model';
import { EmployeeCustomFields } from 'src/app/enums/customFieldType.enum';
import { FormFieldType } from 'src/app/shared/form/formFieldType.enum';
import { toOrganizationTree } from 'src/app/_helpers/org-tree-helper';
import { SampleSurvey } from 'src/app/models/sampleSurvey.model';
import { SurveyListComponent } from 'src/app/components/survey-list/survey-list.component';
import { AgentsListComponent } from 'src/app/components/agents-list/agents-list.component';
import { AgentGroupListComponent } from 'src/app/components/agent-group-list/agent-group-list.component';
import { JurisdictionsListComponent } from 'src/app/components/jurisdictions-list/jurisdictions-list.component';
import { OelTypeComponent } from 'src/app/components/oel-type/oel-type.component';
import { SamplingEquipmentComponent } from 'src/app/components/sampling-equipment/sampling-equipment.component';
import { CalibrationEquipmentComponent } from 'src/app/components/calibration-equipment/calibration-equipment.component';
import { PpeListComponent } from 'src/app/components/ppe-list/ppe-list.component';
import { SamplingEquipment } from 'src/app/models/samplingEquipment.model';
import { CalibrationEquipment } from 'src/app/models/calibrationEquipment.model';
import { EndpointsTableComponent } from 'src/app/components/endpoints-table/endpoints-table.component';
import { UserListComponent } from 'src/app/components/user-list/user-list.component';
import { SegListComponent } from 'src/app/components/seg-list/seg-list.component';
import { SampleListComponent } from 'src/app/components/sample-list/sample-list.component';
import { OperatorTypeEnum } from 'src/app/enums/operatorType.enum';
import { OelTypeService } from 'src/app/services/oel-type.service';
import { AreaUnit, LengthUnit } from 'src/app/enums/unitPreferences.enum';
import { JurisdictionService } from 'src/app/services/jurisdiction.service';
import { ShiftType } from 'src/app/enums/shiftTypeValue.enum';
import { CustomObjectTypeEnum } from 'src/app/enums/customObjectType.enum';
import { SampleTasks } from 'src/app/models/sampleTasks.model';
import { FormControl } from '@angular/forms';
import { OvertimeFrequencyEnum } from 'src/app/enums/overtimeFrequency.enum';
import { ShiftService } from 'src/app/services/shift.service';
import { ParameterTypeEnum } from 'src/app/enums/parameterType.enum';
import { VoidReasonDialogComponent, IVoidReasonResult } from 'src/app/modals/void-reason-dialog/void-reason-dialog.component';
import { CalDriftWarningDialogComponent, CalDriftWarningResult } from 'src/app/modals/cal-drift-warning-dialog/cal-drift-warning-dialog.component';
import { TenantRiskService } from 'src/app/services/tenantRisk.service';
import { SampleValidationConfig } from 'src/app/models/sampleValidationConfig.model';
import { CAL_DRIFT_VOID_REASON } from 'src/app/shared/constants/sampleValidationRules.constants';
import { environment } from 'src/environments/environment';
import { calVariabilityPercent, maxCalDriftPercentFor, shouldWarnCalDrift } from 'src/app/shared/utils/cal-drift.util';
import { LocalStorageConstants } from 'src/app/shared/constants/localStorage.constants';
import { readCachedSelection } from 'src/app/shared/utils/cached-selection.util';
import { SampleTaskManagerService } from './sample-task-manager.service';
import { SampleDataConverterService } from './sample-data-converter.service';
import { SampleCustomEntityService } from './sample-custom-entity.service';
import { SampleAgentJurisdictionService } from './sample-agent-jurisdiction.service';
import { SegShiftValues } from './sample-agent-jurisdiction.model';
import { SampleFormFieldBuilderService } from './sample-form-field.service';
import { DEFAULT_PAGE_SIZE } from 'src/app/constants/customEntity.constants';
import { PpeAssignment } from 'src/app/models/ppeAssignment.model';
import { SampleTemplateService } from 'src/app/services/sampleTemplate.service';
import { SampleDialogTemplateEditData, SampleTemplate, SampleTemplatePickerOption, SampleTemplateSettings } from 'src/app/models/sampleTemplate.model';
import { TemplateSaveDialogComponent } from 'src/app/common-components/template-save-dialog/template-save-dialog.component';
import { TemplateSaveDialogData, TemplateSaveDialogResult } from 'src/app/common-components/template-save-dialog/template-save-dialog.model';
import { IFormDialogData } from 'src/app/shared/form/form.component';
import { CreatePayload } from 'src/app/shared/grid/crud.service';
import { SaveTemplateMode, SAVE_TEMPLATE_MODE_LABELS } from 'src/app/enums/saveTemplateMode.enum';
import { FileAttachmentService } from 'src/app/services/file-attachment.service';
import { WeatherService } from 'src/app/services/weather.service';
import { SampleWeatherService } from './sample-weather.service';
import { WeatherFetchStatus } from 'src/app/enums/weatherFetchStatus.enum';
import { SampleWeatherValues, WeatherCoordinates } from 'src/app/models/weather.model';
import { SecurityProfileEnum } from 'src/app/enums/securityProfile.enum';
import { UserIdentity } from 'src/app/models/userIdentity.model';
import { WeatherSourceType } from 'src/app/enums/WeatherSourceType.enum';
import { TemplateFieldState } from 'src/app/models/templateFieldState.model';

@Component({
  standalone: false,
  selector: 'app-sample-dialog',
  templateUrl: './sample-dialog.component.html',
  styleUrls: ['./sample-dialog.component.scss', '../../shared/form/form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    SampleTaskManagerService,
    SampleDataConverterService,
    SampleCustomEntityService,
    SampleAgentJurisdictionService,
    SampleFormFieldBuilderService,
    SampleWeatherService,
  ]
})
export class SampleDialogComponent extends FormComponent<Sample> implements OnInit, OnDestroy, FlyoutClosable {
  @ViewChild('stepTpl') stepTpl!: TemplateRef<any>;
  @ViewChild('tasksTableTemplate') tasksTableTemplate!: TemplateRef<any>;
  entity = new Sample();
  /** Tracks the previous sampling date so the time can be reset to 00:00 when the date changes. */
  private previousStartDate: Date | null = null;
  stepperConfig!: StepperConfig;
  currentStep: StepConfig;
  customEntities: CustomEntity[];
  employees: Lookup[] = [];
  sensors: Lookup[];
  segs: Lookup[];
  organizationLevels: OrganizationLevel[] = [];
  percentageInputVisibility: boolean[] = [];
  sampleSurveys: Lookup[];
  agents: Lookup[];
  agentGroups: Lookup[];
  jurisdictions: Lookup[];
  oelTypes: Lookup[] = [];
  calibrationEquipments: Lookup[] = [];
  samplingEquipments: Lookup[] = [];
  customObjectsList: CustomField[] = [];
  useAgentGroups: boolean = false;
  coId: string | number;
  initialFieldProps: Map<string, { required: boolean }> = new Map();
  locations: CustomEntity[];
  ppeList: Lookup[] = [];
  sampleMediaList: Lookup[] = [];
  users: Lookup[] = [];
  attachedFiles: FileAttachment[] = [];
  isFormInitialized = false;
  isInitial = true;
  initialFields: FormField[];
  sampleCategoryEnum = SampleCategoryEnum;
  sampleTypeEnum = SampleTypeEnum;
  sampleStatusEnum = SampleStatusEnum;
  sampleStatusList: ReturnType<typeof getEnumLookup> = getEnumLookup(SampleStatusEnum);
  getStatusBadgeClass = getStatusBadgeClass;
  initialSampleStatus: SampleStatusEnum;
  statusBadgeClassById: Map<number, string> = new Map(
    (Object.values(SampleStatusEnum).filter(v => typeof v === 'number') as number[])
      .map(id => [id, getStatusBadgeClass(id)])
  );
  employeeFields: FormField[] = [];
  selectedOrgLevel: { id?: string; orgLevelType?: OrgLevelTypeEnum; name?: string } | null = null;
  groupAgents: Lookup[] = [];
  allJurisdictions: JurisdictionLookup[] = [];
  displayedColumns = [nameOf<SampleTasks>(x => x.taskId), nameOf<SampleTasks>(x => x.approximateTimeMinutes), nameOf<SampleTasks>(x => x.applicablePpeWorn), 'actions'];
  taskList: SampleTasks[] = [];
  filteredTasks: (GroupLookup & { id: number; name: string })[][] = [];
  taskSearch: string[] = [];
  tasks: (GroupLookup & { id: number; name: string })[] = [];
  searchControl = new FormControl();
  previousTaskValues = new Map<SampleTasks, string>();
  shifts: Lookup[] = [];

  availableTemplates: Lookup[] = [];
  allTemplates: SampleTemplatePickerOption[] = [];
  private suppressDefaultTemplateAutoApply = false;
  selectedTemplateId: string | null = null;
  defaultTemplateName: string | null = null;
  templateFilledFields: Set<string> = new Set();
  templateEditedFields: Set<string> = new Set();
  private segLockedFields: Set<string> = new Set();
  private configDefaultFields: Set<string> = new Set();
  private configDefaultValues: Map<string, unknown> = new Map();
  templateFieldStates = new Map<string, TemplateFieldState>();
  isDefaultTemplateBannerVisible: boolean = false;
  isTemplateEdit: boolean = false;
  isTemplateDirtyState = false;
  private editingTemplate: SampleTemplate | null = null;
  private templateBaseline: string | null = null;
  private appliedTemplate: SampleTemplate | null = null;
  saveTemplateMode: SaveTemplateMode = SaveTemplateMode.Create;
  saveTemplateLabel: string = SAVE_TEMPLATE_MODE_LABELS[SaveTemplateMode.Create];
  isSavingTemplate = false;
  private templateSelectionRequestId = 0;

  canFetchWeather = false;
  weatherFetchStatus = WeatherFetchStatus.Idle;
  readonly weatherFetchStatusEnum = WeatherFetchStatus;
  isWeatherFetchDisabled = true;
  isWeatherLookupUnavailable = false;
  weatherHint: string | null = null;
  weatherMessage: string | null = null;
  private weatherCoordinates: WeatherCoordinates | null = null;
  private weatherSamplingDay: Date | null = null;
  private isWeatherLocationPending = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(FLYOUT_DATA) public data: IFormDialogData | SampleDialogTemplateEditData,
    dialogRef: MatDialogRef<SampleDialogComponent>,
    protected injector: Injector,
    private dialog: MatDialog,
    private sensorService: SensorService,
    private sampleService: SampleService,
    private customEntityService: CustomEntityService,
    private segService: SegService,
    private sampleSurveyService: SampleSurveyService,
    private agentService: AgentService,
    private agentGroupService: AgentGroupService,
    private organizationLevelService: OrganizationLevelService,
    protected valueConversionService: ValueConversionService,
    private eventService: EventService,
    private authService: AuthService,
    private customObjectService: CustomObjectService,
    private calibrationEquipmentService: CalibrationEquipmentService,
    private samplingEquipmentService: SamplingEquipmentService,
    private agentJurisdictionService: AgentJurisdictionService,
    private sampleMediaService: SampleMediaService,
    private userService: UserService,
    private ppeService: PpeService,
    private oelTypeService: OelTypeService,
    private jurisdictionService: JurisdictionService,
    private shiftService: ShiftService,
    private taskManagerService: SampleTaskManagerService,
    private dataConverterService: SampleDataConverterService,
    private customEntityLoaderService: SampleCustomEntityService,
    private agentJurisdictionLoaderService: SampleAgentJurisdictionService,
    private formFieldService: SampleFormFieldBuilderService,
    private sampleTemplateService: SampleTemplateService,
    private fileAttachmentService: FileAttachmentService,
    private tenantRiskService: TenantRiskService,
    private weatherService: WeatherService,
    private sampleWeatherService: SampleWeatherService
  ) {
    const isTemplateEditMode = 'editSampleTemplateId' in data;
    const formData: IFormDialogData = isTemplateEditMode ? { id: '' } : (data as IFormDialogData);
    super(dialogRef, sampleService, formData, isTemplateEditMode ? 'Edit Template' : 'Sample', injector);
    this.isTemplateEdit = isTemplateEditMode;
  }

  ngOnInit() {
    this.isFormLoading = true;
    const currentUser = this.authService.getCurrentUser();
    this.coId = currentUser.preferences?.endPointId;
    this.canFetchWeather = environment.enableWeatherFetch && this.canUserFetchWeather(currentUser);
    this.selectedOrgLevel = readCachedSelection<NonNullable<typeof this.selectedOrgLevel>>(LocalStorageConstants.selectedOrg) ?? {};
    const orgPayload = JSON.stringify({ organizationLevelId: this.selectedOrgLevel?.id });
    forkJoin({
      entity: this.getEntity(),
      sensors: this.sensorService.getAll(),
      segs: this.segService.getAll(orgPayload),
      organizationLevels: this.organizationLevelService.getAll(),
      sampleSurveys: this.sampleSurveyService.getAll(JSON.stringify({ surveyStatus: '0,1' })),
      agentGroups: this.agentGroupService.getAll(orgPayload),
      calibrationEquipments: this.calibrationEquipmentService.getAll(orgPayload),
      sampleMediaList: this.sampleMediaService.getAll(),
      users: this.userService.getAll(),
      jurisdictions: this.jurisdictionService.getAll(orgPayload),
      shifts: this.shiftService.getAll()
    }).subscribe({
      next: result => {
        this.entity = result.entity;
        this.sensors = result.sensors;
        // SEG and Agent Group dropdowns are tagged "linked to my site": only show linked entries.
        this.segs = filterLinkedToMySiteOptions(result.segs, [LINKED_TO_MY_SITE_FIELD]);
        this.sampleSurveys = result.sampleSurveys;
        this.agentGroups = filterLinkedToMySiteOptions(result.agentGroups, [LINKED_TO_MY_SITE_FIELD]);
        this.organizationLevels = result.organizationLevels;
        this.shifts = result.shifts;
        this.allJurisdictions = result.jurisdictions;
        if (!this.entity.id && this.selectedOrgLevel.orgLevelType === OrgLevelTypeEnum.Site) {
          this.entity = { ...this.entity, organizationLevelName: this.selectedOrgLevel?.name, organizationLevelId: this.selectedOrgLevel?.id };
        }
        this.calibrationEquipments = result.calibrationEquipments;
        this.sampleMediaList = result.sampleMediaList;
        this.users = result.users.map((user: any) => ({ id: user.id, name: user.userName }));
        this.loadTasks().subscribe(res => {
          this.tasks = res.map((group, index) => ({
            id: index,
            name: group.groupName,
            ...group
          }));
        });
        this.initForm();
        this.isFormLoading = false;
        if (this.isTemplateEdit) {
          this.loadTemplateForEdit();
        } else if (this.isAdd) {
          this.loadAvailableTemplates();
          this.loadAllTemplatesForPicker();
        }
      },
      error: error => {
        this.toastService.showError(error);
        this.isFormLoading = false;
      }
    });
    this.loadSampleValidationConfig();
  }

  private sampleValidationConfig: SampleValidationConfig | null = null;

  private loadSampleValidationConfig(): void {
    this.tenantRiskService.getCurrent().subscribe({
      next: (tenantRisk) => { this.sampleValidationConfig = tenantRisk?.sampleValidationConfig ?? null; },
      error: () => { this.sampleValidationConfig = null; }
    });
  }

  private getMaxCalDriftPercent(sampleType: number): number | null {
    return maxCalDriftPercentFor(this.sampleValidationConfig, sampleType);
  }

  loadSampleTasks(): Observable<SampleTasks[]> {
    return this.taskManagerService.loadSampleTasks(this.entity.id);
  }

  loadTasks(): Observable<GroupLookup[]> {
    return this.taskManagerService.loadTasks();
  }

  private initTaskData() {
    forkJoin({
      sampleTasks: this.loadSampleTasks(),
      groupLookups: this.loadTasks()
    }).subscribe(({ sampleTasks: sampleTasksRes, groupLookups }) => {
      this.taskList = sampleTasksRes;
      this.tasks = groupLookups.map((group, index) => ({
        id: index,
        name: group.groupName,
        ...group
      }));

      const taskData = this.taskManagerService.initTaskData(this.entity, this.tasks);
      this.filteredTasks = taskData.filteredTasks;
      this.taskSearch = taskData.taskSearch;
      this.previousTaskValues = taskData.previousTaskValues;
    });
  }

  isTaskSelected(taskId: Lookup['id'], currentRow: SampleTasks): boolean {
    return this.taskManagerService.isTaskSelected(taskId, currentRow, this.entity.sampleTasks || []);
  }

  onTaskSelected(taskId: string, element: SampleTasks) {
    this.taskManagerService.onTaskSelected(taskId, element, this.tasks);
  }

  addTaskRow() {
    const newRow = this.taskManagerService.addTaskRow(this.entity);
    this.previousTaskValues.set(newRow, null);
    this.filteredTasks.push([...this.tasks]);
    this.taskSearch.push('');
  }

  filterTasks(searchValue: string, rowIndex: number) {
    this.taskManagerService.filterTasks(searchValue, rowIndex, this.tasks, this.filteredTasks);
    this.taskSearch[rowIndex] = searchValue;
  }

  removeTaskRow(index: number) {
    const removedTask = this.entity.sampleTasks?.[index];
    if (removedTask) {
      this.previousTaskValues.delete(removedTask);
    }
    this.taskManagerService.removeTaskRow(index, this.entity, this.filteredTasks, this.taskSearch);
  }

  openTaskDialog(element?: SampleTasks) {
    this.taskManagerService.openTaskDialog(element).pipe(
      filter(result => !!result),
      switchMap(result =>
        this.loadTasks().pipe(
          map(res => ({ result, res }))
        )
      )
    ).subscribe(({ result, res }) => {
      this.tasks = res.map((group, index) => ({
        id: index,
        name: group.groupName,
        ...group
      }));
      this.filteredTasks = (this.entity.sampleTasks || []).map((_, i) => {
        const search = this.taskSearch?.[i];
        return search
          ? this.tasks
              .map(group => ({
                ...group,
                items: (group.items || []).filter(item =>
                  item.name?.toLowerCase().includes(search.toLowerCase())
                )
              }))
              .filter(group => group.items?.length)
          : [...this.tasks];
      });

      if (element && result?.id) {
        this.onTaskSelected(result.id as string, element);
      }
    });
  }

  getCustomEntities() {
    const handleError = (error: any) => {
      console.error(error);
      this.isFormLoading = false;
      this.toastService.showError(error);
      this.customObjectsList = [];
      if (!this.isFormInitialized) this.initForm();
    };

    const isLocationForm = isVisibleOnly([
      SampleTypeCategoryCombos.airArea,
      SampleTypeCategoryCombos.noiseArea,
      SampleTypeCategoryCombos.wipeArea,
      SampleTypeCategoryCombos.wipeBlank,
    ])(this.entity);

    this.customObjectService.getAll().pipe(
      switchMap((typeLookups) => {
        const entityType = typeLookups.find(t =>
          isLocationForm ? t.name.includes('Location') : t.name === 'Employee'
        );

        if (!entityType) {
          this.customObjectsList = [];
          this.isFormLoading = false;
          if (!this.isFormInitialized) this.initForm();
          return EMPTY;
        }
        this.coId = entityType.id;
        let filterBy = {};
        if (this.entity?.endPoint) {
          filterBy = { name: this.entity.endPoint.name };
        }

        return this.customEntityService
          // TODO DASH-2170: Implement virtual-scroll pagination for custom entity lookups.
          // Currently capped at DEFAULT_PAGE_SIZE (100), which silently truncates large employee/location lists.
          .get('', 'id', 'asc', 0, DEFAULT_PAGE_SIZE, JSON.stringify(filterBy), new HttpHeaders({ coid: this.coId }))
          .pipe(
            switchMap((res) => {
              this.customEntities = res.data;
              return this.ensureEndPointEntityLoaded().pipe(
                switchMap(() => {
                  const employeeField = this.fields.find(f => f.property === 'search_employee');
                  if (isLocationForm) {
                    this.locations = this.customEntities;
                    if (this.fields) {
                      const locationField = this.fields.find(f => f.property === 'location');
                      if (locationField) locationField.options = this.locations;
                      if (this.entity.endPoint) {
                        this.entity['location'] = this.entity.endPoint.id;
                      }
                    }
                  } else {
                    this.employees = this.customEntities;
                    if (this.fields) {
                      if (employeeField) {
                        employeeField.options = this.employees;
                        employeeField.additonalSearchData = { coId: this.coId };
                        if (this.entity.endPoint?.name) {
                          this.searchEntities(this.entity.endPoint.name, employeeField);
                        }
                      }
                    }
                  }
                  if (!this.isFormInitialized) this.initForm();

                  return this.customObjectService
                    .getCustomObjectFields(this.coId).pipe(
                      tap((fields) => {
                        this.customObjectsList = fields.filter(f =>
                          this.isCustomFieldKey(f.property) && EmployeeCustomFields.includes(f.type)
                        );
                        if (employeeField && Array.isArray(this.customObjectsList)) {
                          const mappedKeys = this.customObjectsList
                            .filter(obj => obj && typeof obj.property === 'string')
                            .map(obj => obj.property);
                          employeeField.searchKeys = [...mappedKeys, 'name'];
                          const config = buildEmployeeOptionConfig(this.customObjectsList);
                          employeeField.optionTemplateFields = config.optionTemplateFields;
                          employeeField.optionTemplateLabelMap = config.optionTemplateLabelMap;
                        }
                        if (!this.isFormInitialized) this.initForm();
                        this.createEmployeeFields();
                        this.isFormLoading = false;
                      })
                    );
                })
              );
            })
          );
      })
    ).subscribe({ error: handleError });
  }

  private ensureEndPointEntityLoaded(): Observable<CustomEntity | null> {
    const endPointId = this.entity.endPointId;
    if (!endPointId || this.entity.endPoint?.id === endPointId || this.customEntities.some(e => e.id === endPointId)) {
      return of(null);
    }
    return this.customEntityService.getCustomEntity(endPointId, this.coId).pipe(
      tap((customEntity: CustomEntity | null) => {
        if (customEntity && customEntity.customObjectId === this.coId
          && !this.customEntities.some(e => e.id === customEntity.id)) {
          this.customEntities = [...this.customEntities, customEntity];
        }
      })
    );
  }

  showStepper() {
    this.isInitial = false;
    this.currentStep = this.stepperConfig.steps[0];
    this.updateFieldVisibility();
  }

  initForm() {
    this.initModel();
    this.initFields();
  }

  getNewObject(): Sample {
    return new Sample();
  }

  /**
   * Resets the sampling time to 00:00 whenever the date portion of the
   * "Date and Time of Sampling" picker changes (the time should not carry over).
   */
  private onStartDateChange(value: Date | string): void {
    const newDate = value instanceof Date ? value : this.dateFormatService.convertStringToDate(value as string);
    if (newDate && this.previousStartDate && isDifferentCalendarDay(newDate, this.previousStartDate)) {
      const reset = new Date(newDate);
      reset.setHours(0, 0, 0, 0);
      this.entity.startDate = reset;
      this.previousStartDate = new Date(reset);
      return;
    }
    this.previousStartDate = newDate ? new Date(newDate) : null;
  }

  /**
   * Defaults the End Time to 12:00 PM for a new sample once a sample type/category
   * that shows the End Time field has been selected (only when not already set).
   */
  private applyDefaultEndTime(): void {
    if (!this.isAdd || this.entity.endDate) return;
    const endTimeVisible = isVisibleOnly([
      SampleTypeCategoryCombos.airPersonal,
      SampleTypeCategoryCombos.airArea,
      SampleTypeCategoryCombos.noisePersonal,
      SampleTypeCategoryCombos.noiseArea
    ])(this.entity);
    if (endTimeVisible) {
      this.entity.endDate = DEFAULT_SAMPLE_END_TIME;
    }
  }

  initModel(): void {
    this.initialSampleStatus = this.entity.sampleStatus ?? SampleStatusEnum.Draft;

    if (!this.isAdd) {
      if (this.entity.startDate) {
        this.entity.startDate = this.dateFormatService.convertStringToDate(
          this.dateFormatService.convertUTCDateStringToUserTimeZoneString(this.entity.startDate as string)
        );
        this.previousStartDate = this.entity.startDate instanceof Date ? new Date(this.entity.startDate) : null;
      }
      if (this.entity.endDate) {
        const p = this.dateFormatService.utcToLocalDateAndTime(this.entity.endDate as string);
        this.entity.endDate = p.time;
      }
      if (this.entity.dateCreated && (this.entity.dateCreated as string).includes('T')) {
        const p = this.dateFormatService.utcToLocalDateAndTime(this.entity.dateCreated as string);
        this.entity.dateCreated = p.date;
      }
      const ihResults = this.entity.ihLabResults;
      if (ihResults?.length) {
        this.entity.agentIds = [...new Set(ihResults.map(result => result.agentId))];
        this.entity.jurisdictionIds = [...new Set(ihResults.map(result => result.jurisdictionId))];
        this.entity.oelTypeId = this.entity.oelTypeId ?? ihResults.find(result => result.oelTypeId)?.oelTypeId;
        const groupIds = [...new Set(ihResults.map(r => r.agentGroupId))];
        if (groupIds.length === 1 && groupIds[0] != null) {
          this.entity.agentGroupId = groupIds[0];
          this.useAgentGroups = true;
        }
      }
      this.entity.ppeAssignmentList = (this.entity.ppeAssignments || []).map(ppe => ppe.ppeId);
      if (this.entity.ppeAssignments?.length) {
        for (const ppe of this.entity.ppeAssignments as PpeAssignment[]) {
          if (ppe.startDate) {
            ppe.startDate = this.dateFormatService.convertUTCDateStringToUserTimeZoneString(ppe.startDate as string);
          }
          if (ppe.endDate) {
            ppe.endDate = this.dateFormatService.convertUTCDateStringToUserTimeZoneString(ppe.endDate as string);
          }
        }
      }
      if (this.entity.sampleTasks?.length) {
        for (const task of this.entity.sampleTasks) {
          if (task.startDate) {
            task.startDate = this.dateFormatService.convertUTCDateStringToUserTimeZoneString(task.startDate);
          }
          if (task.endDate) {
            task.endDate = this.dateFormatService.convertUTCDateStringToUserTimeZoneString(task.endDate);
          }
        }
      }
      if (this.entity.sampleType != undefined && this.entity.sampleType != null) this.onSampleTypeChanged();
      const isNoise = this.entity?.sampleType === SampleTypeEnum.Noise;
      if (!isNoise && this.entity.samplePreCal != null) {
        this.entity.samplePreCal = this.valueConversionService.getParameterValueFromUserPreferences(this.entity.samplePreCal, ParameterTypeEnum.FlowRate);
      }
      if (!isNoise && this.entity.samplePostCal != null) {
        this.entity.samplePostCal = this.valueConversionService.getParameterValueFromUserPreferences(this.entity.samplePostCal, ParameterTypeEnum.FlowRate);
      }
      if (this.entity.temperatureMinC != null) {
        this.entity.temperatureMinC = this.valueConversionService.getParameterValueFromUserPreferences(this.entity.temperatureMinC, ParameterTypeEnum.Temperature);
      }
      if (this.entity.temperatureMaxC != null) {
        this.entity.temperatureMaxC = this.valueConversionService.getParameterValueFromUserPreferences(this.entity.temperatureMaxC, ParameterTypeEnum.Temperature);
      }
      if (this.entity.shiftLength) this.entity.shiftLength = this.valueConversionService.convertSecondsToHours(this.entity.shiftLength);
      if (this.entity.averageWeeklyHours_Seconds) this.entity.averageWeeklyHours_Seconds = this.valueConversionService.convertSecondsToHours(this.entity.averageWeeklyHours_Seconds);
      this.getCustomEntities();
      if (this.entity.wipeDimensions) {
        try {
          const dimensions = JSON.parse(this.entity.wipeDimensions);
          if (dimensions && typeof dimensions === 'object') {
            this.entity['length'] = dimensions.length;
            this.entity['width'] = dimensions.width;
            this.entity['area'] = dimensions.area;
            this.entity['lengthUnit'] = dimensions.unit !== undefined ? dimensions.unit : LengthUnit.cm;
          }
        } catch (error) {
          console.error('Failed to parse wipeDimensions:', error);
        }
      }
      if (!this.entity['length'] && !this.entity['width'] && !this.entity['area'] && ihResults?.length) {
        const firstWithDimensions = ihResults.find(result => result.wipeDimensions);
        if (firstWithDimensions?.wipeDimensions) {
          try {
            const dimensions = JSON.parse(firstWithDimensions.wipeDimensions);
            if (dimensions && typeof dimensions === 'object') {
              this.entity['length'] = dimensions.length;
              this.entity['width'] = dimensions.width;
              this.entity['area'] = dimensions.area;
              this.entity['lengthUnit'] = dimensions.unit !== undefined ? dimensions.unit : LengthUnit.cm;
            }
          } catch (error) {
            console.error('Failed to parse wipeDimensions:', error);
          }
        }
      }
      this.getSiteInfo();
      if (this.entity.applyShiftCorrection === undefined || this.entity.applyShiftCorrection === null) {
        this.entity.applyShiftCorrection = true;
      }
      this.entity.overtimeFrequency = this.entity.overtimeFrequency ?? OvertimeFrequencyEnum.Never;
      this.entity.symptoms = this.entity.symptoms ?? false;
    } else {
      this.entity.applyShiftCorrection = true;
      this.entity.sampleStatus = SampleStatusEnum.Draft;
      this.entity.unsampledTimeCorrection = UnsampledTimeCorrectionType.AssumeUniform;
      this.entity.sampledByUserId = this.authService.getCurrentUser()?.userId;
      this.entity.overtimeFrequency = OvertimeFrequencyEnum.Never;
      this.entity.symptoms = false;
      if (this.entity.organizationLevelId) {
        this.getSiteInfo();
      }
    }

    this.sampleStatusList = getFilteredSampleStatuses(getEnumLookup(SampleStatusEnum), this.entity?.sampleType, this.entity?.sampleCategory, this.entity?.sampleStatus);
    if (this.entity.fileAttachmentIds?.length) {
      this.attachedFiles = this.entity.fileAttachments;
    } else {
      this.entity.fileAttachmentIds = [];
    }
    this.entity.selectedBy = this.useAgentGroups ? 1 : 0;
    this.applyPressureCorrectionChanges();
    this.applyShiftCorrectionChanges();
    if (this.entity['lengthUnit'] == null) {
      this.entity['lengthUnit'] = LengthUnit.cm;
    }

    this.applyConfigDefaults();
  }

  private applyConfigDefaults(): void {
    if (!this.isAdd) return;
    applyFieldConfigDefaults(this.entity, this.columnDetails).forEach(key => {
      this.configDefaultFields.add(key);
      this.configDefaultValues.set(key, structuredClone(this.entity[key]));
    });
  }

  updateFlowFields() {
    this.formFieldService.updateFlowFields(this.entity, this.fields);
  }

  validate(): boolean {
    if (this.isTemplateEdit) return true;

    if (this.entity.shiftLength > 24 || this.entity.shiftLength < 0) {
      this.toastService.displayErrorMessage('Shift Length should be between 0 and 24', true);
      return false;
    }

    if (!this.entity.startDate) {
      this.toastService.displayErrorMessage('Date and Time of Sampling is mandatory', true);
      return false;
    }

    const requiresPressure =
      isVisibleOnly([SampleTypeCategoryCombos.airPersonal, SampleTypeCategoryCombos.airArea])(this.entity) &&
      this.entity.applyPressureCorrection;
      if (requiresPressure && this.entity.pressureMmhg == null) {
      this.toastService.displayErrorMessage('Pressure is mandatory when Pressure Correction is applied', true);
      return false;
    }

    const isPersonalSample = isVisibleOnly([SampleTypeCategoryCombos.airPersonal, SampleTypeCategoryCombos.noisePersonal, SampleTypeCategoryCombos.wipePersonal, SampleTypeCategoryCombos.biologicalPersonal, SampleTypeCategoryCombos.psychologicalPersonal])(this.entity);
    if (isPersonalSample) {
      if (
        (this.entity.exposureTypicality === ExposureTypicality.AtypicallyHigh ||
          this.entity.exposureTypicality === ExposureTypicality.AtypicallyLow) &&
        (!this.entity.exposureAtypicalComments || this.entity.exposureAtypicalComments.trim() === '')
      ) {
        this.toastService.displayErrorMessage(
          this.translateService.getDynamicTranslation('Atypical Exposure Comments are required when exposure is atypical.'),
          true
        );
        return false;
      }

      if (
        this.entity.symptoms &&
        (!this.entity.symptomComments || this.entity.symptomComments.trim() === '')
      ) {
        this.toastService.displayErrorMessage(
          this.translateService.getDynamicTranslation('Symptom Comments are required when symptoms are reported.'),
          true
        );
        return false;
      }
    }

    if (!isVisibleOnly([SampleTypeCategoryCombos.airPersonal, SampleTypeCategoryCombos.airArea])(this.entity)) return true;
    if (this.useAgentGroups && !this.entity.agentGroupId) {
      this.toastService.displayErrorMessage('Select Agent Group', true);
      return false;
    } else if (!this.useAgentGroups && !this.entity.agentIds?.length) {
      this.toastService.displayErrorMessage('Select At least one Agent', true);
      return false;
    } else if (!this.useAgentGroups && !this.entity.jurisdictionIds?.length) {
      this.toastService.displayErrorMessage('Select At least one Jurisdiction', true);
      return false;
    }
    return true;
  }

  onSelectionChange(event: any, field: FormField): void {
    if (!event?.value) return;
    const customEntity = field.options.find(res => res.id === event?.value) as CustomEntity;
    if (!customEntity) return;
    this.entity.endPointId = customEntity.id;

    this.customObjectsList?.forEach(obj => {
      if (!obj.property || !this.isCustomFieldKey(obj.property)) return;
      this.entity[obj.property] = customEntity[obj.property];
    });
    if (customEntity.organizationLevelId) {
      this.entity.endpointOrganizationLevelId = customEntity.organizationLevelId;
      this.entity.organizationLevelId = customEntity.organizationLevelId;
      this.loadSegShiftValues();
    }
  }


  onShiftLengthInputChange(event: any, field: FormField): void {
    if (event.target.value != null) {
      if (event.target.value > 24) {
        this.entity.shiftLength = 24;
      }
      else if (event.target.value < 0) {
        this.entity.shiftLength = 0;
      }
    }
  }

  onBeforeSave(model: Sample): void {
    // Snapshot PPE assignments with dates BEFORE converter strips them
    const ppeAssignmentsWithDates = model.ppeAssignments?.length ? [...model.ppeAssignments] : [];

    // Convert model from user format to API format
    this.dataConverterService.convertBeforeSave(model, this.entity);

    model.sampleTasks = this.taskManagerService.prepareTasksForSave(model.sampleTasks);

    // Validate no duplicate tasks
    const validation = this.taskManagerService.validateNoDuplicateTasks(model.sampleTasks);
    if (validation.hasDuplicates) {
      this.toastService.displayErrorMessage(
        `${this.translateService.getDynamicTranslation('Duplicate Task Id(s):')} ${validation.duplicateIds.join(', ')}`,
        true
      );
      throw new Error('Duplicate Task Id(s)');
    }

    if (model.sampleTasks?.length) {
      for (const task of model.sampleTasks) {
        if (task.startDate) {
          task.startDate = this.dateFormatService.convertUserTimeZoneStringToUTCDateString(task.startDate);
        }
        if (task.endDate) {
          task.endDate = this.dateFormatService.convertUserTimeZoneStringToUTCDateString(task.endDate);
        }
      }
    }

    // Handle PPE assignment date conversions (not done by converter service)
    // Use snapshot taken BEFORE convertBeforeSave stripped the dates
    model.ppeAssignments = (model.ppeAssignmentList ?? []).map(ppeId => {
      const existing = ppeAssignmentsWithDates.find(x => x.ppeId === ppeId);
      const assignment: PpeAssignmentPayload = { id: existing?.id, ppeId };
      if (existing?.startDate) {
        assignment.startDate = this.dateFormatService.convertUserTimeZoneStringToUTCDateString(existing.startDate as string);
      }
      if (existing?.endDate) {
        assignment.endDate = this.dateFormatService.convertUserTimeZoneStringToUTCDateString(existing.endDate as string);
      }
      return assignment;
    });
  }

  getEntity(): Observable<Sample> {
    return this.isAdd ? of(this.getNewObject()) : this.sampleService.getSampleById(this.entityId);
  }

  override saveAction(model: Sample) {
    if (this.isTemplateEdit && this.editingTemplate) {
      const updatedTemplate: SampleTemplate = { ...this.editingTemplate, settings: this.buildTemplateSettings() };
      return this.sampleTemplateService.update(updatedTemplate);
    }
    return this.isAdd ? this.sampleService.createSample(model) : this.service.update(model);
  }

  override afterSaveAction(response: unknown): void {
    this.isLoading = false;
    if (this.isTemplateEdit) {
      this.templateBaseline = JSON.stringify(this.buildTemplateSettings());
      this.isTemplateDirtyState = false;
      this.toastService.showSuccess('Template updated successfully', true);
      this.close(response as object);
      return;
    }
    this.toastService.showSuccess('Success', true);
    this.close(response as object);
  }

  canClose(): Promise<boolean> {
    if (!this.isTemplateEdit || !this.isTemplateDirty()) {
      return Promise.resolve(true);
    }
    return this.openConfirmDialog({
      title: 'Discard changes?',
      message: 'You have unsaved changes to this template. Do you want to discard them?',
      primaryButtonText: 'Discard',
      secondaryButtonText: 'Keep editing'
    });
  }

  private openConfirmDialog(options: { title: string; message: string; primaryButtonText: string; secondaryButtonText: string }): Promise<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.translateService.getDynamicTranslation(options.title),
        message: this.translateService.getDynamicTranslation(options.message),
        primaryButtonText: this.translateService.getDynamicTranslation(options.primaryButtonText),
        primaryCallback: null,
        successMessage: '',
        secondaryButtonText: this.translateService.getDynamicTranslation(options.secondaryButtonText),
        errorMessage: ''
      } as ConfirmDialogData,
      width: '440px'
    });
    return firstValueFrom(dialogRef.afterClosed()).then(result => result === true);
  }

  private isTemplateDirty(): boolean {
    if (this.templateBaseline == null) {
      return false;
    }
    return JSON.stringify(this.buildTemplateSettings()) !== this.templateBaseline;
  }

  /**
   * Pre-save gate for the Calibration Variability Exceeded warning. It has to run *before* the save:
   * the API rejects a locked -> unlocked transition, so a locked status persisted here could not be
   * undone if the user then cancelled the void flow, stranding the sample (DASH-3182).
   *
   * Continue -> save as requested. Void -> save as Void with the prefilled, editable reason.
   * Cancel / dismiss -> nothing is saved and the sample keeps the status it already had.
   */
  private async ensureCalDriftAcknowledged(): Promise<boolean> {
    const preCal = this.entity.samplePreCal;
    const postCal = this.entity.samplePostCal;
    const maxCalDriftPercent = this.getMaxCalDriftPercent(this.entity.sampleType);
    const needsWarning = shouldWarnCalDrift({
      currentStatus: this.initialSampleStatus,
      targetStatus: this.entity.sampleStatus,
      preCal,
      postCal,
      maxCalDriftPercent
    });
    if (!needsWarning) {
      return true;
    }

    const result: CalDriftWarningResult | undefined = await firstValueFrom(
      this.dialog.open(CalDriftWarningDialogComponent, {
        data: { calVariabilityPercent: calVariabilityPercent(preCal, postCal), maxCalDriftPercent },
        width: '450px',
      }).afterClosed()
    );
    if (result === CalDriftWarningResult.Continue) {
      return true;
    }
    if (result !== CalDriftWarningResult.Void) {
      return false;
    }

    const voidResult: IVoidReasonResult = await firstValueFrom(
      this.dialog.open(VoidReasonDialogComponent, {
        data: { voidReason: this.translateService.getDynamicTranslation(CAL_DRIFT_VOID_REASON) },
        width: '400px',
      }).afterClosed()
    );
    const voidReason = voidResult?.confirmed ? (voidResult.voidReason?.trim() ?? '') : '';
    if (!voidReason) {
      return false;
    }

    this.entity.sampleStatus = SampleStatusEnum.Void;
    this.entity.voidReason = voidReason;
    // Keeps ensureVoidReasonIfNeeded from prompting a second time for the reason just captured.
    this.initialSampleStatus = SampleStatusEnum.Void;
    return true;
  }

  private async ensureVoidReasonIfNeeded(): Promise<boolean> {
    const isTransitionToVoid =
      this.initialSampleStatus !== SampleStatusEnum.Void &&
      this.entity.sampleStatus === SampleStatusEnum.Void;
    if (isTransitionToVoid) {
      const dialogRef = this.dialog.open(VoidReasonDialogComponent, {
        data: { voidReason: this.entity.voidReason || '' },
        width: '400px',
      });
      const result: IVoidReasonResult = await firstValueFrom(dialogRef.afterClosed());
      if (result?.confirmed && result.voidReason?.trim().length > 0) {
        this.entity.voidReason = result.voidReason.trim();
        this.initialSampleStatus = SampleStatusEnum.Void;
        return true;
      }
      return false;
    }
    return true;
  }

  override async save() {
    // Validate before prompting: never ask the user to void a sample the form would reject anyway.
    if (!this.validate()) {
      return;
    }
    if (!await this.ensureCalDriftAcknowledged()) {
      return;
    }
    const passed = await this.ensureVoidReasonIfNeeded();
    if (passed) {
      super.save();
    }
  }

  updateColumnDetails(fields: FormField[]) {
    if (this.columnDetails) {
      fields.forEach(field => {
        if (!field.property || !this.columnDetails.hasOwnProperty(field.property)) return;
        const config = this.columnDetails[field.property];
        // Strip trailing unit suffix from displayName when additionalLabel already appends unit dynamically,
        // guards against existing FieldConfiguration DB records that may still contain e.g. "(°C)"
        if (config?.displayName)
            field.name = field.additionalLabel
                ? config.displayName.replace(/\s*\([^)]*\)\s*$/, '')
                : config.displayName;
        if (config?.tooltip) field.tooltip = config.tooltip;
        if (typeof config?.isVisibleOnDialog === 'boolean') {
          const originalIsVisible = field.isVisible;
          field.isVisible = (sample) =>
            (originalIsVisible ? originalIsVisible(sample) : true) && config.isVisibleOnDialog;
        }
      })
    }
    return fields;
  }

  initFields() {
    this.isFormInitialized = true;
    const flowRateUnit = this.valueConversionService.getFlowRateUnit();
    const sampleOptions = [{ id: 0, name: this.translateService.getDynamicTranslation("By Agent") }, { id: 1, name: this.translateService.getDynamicTranslation("Agent By Panel") }];

    const sectionVisibility = (fields: FormField[], visibility: SampleCondition): FormField[] => {
      return fields.map(field => ({
        ...field, isVisible: (sample) => visibility(sample) && (field.isVisible?.(sample) ?? true)
      }));
    };

    const { airPersonal, airArea, airBlank, noisePersonal, noiseArea, wipeArea, wipeBlank, wipePersonal, biologicalPersonal, psychologicalPersonal } = SampleTypeCategoryCombos;

    const hideAirEquipment = isVisibleExcept([airBlank, wipeBlank, wipeArea, wipePersonal, biologicalPersonal]);

    const segSearchfields = [nameOf<SEG>(x => x.name), nameOf<SEG>(x => x.code), nameOf<SEG>(x => x.addedToMySite)];
    const agentSearchfields = [nameOf<Agent>(x => x.name), nameOf<Agent>(x => x.casId), nameOf<Agent>(x => x.addedToMySite)];
    const agentGroupSearchfields = [nameOf<AgentGroup>(x => x.name), nameOf<AgentGroup>(x => x.casId), nameOf<AgentGroup>(x => x.addedToMySite)];
    const jurisdictionSearchfields = [nameOf<Jurisdiction>(x => x.name), nameOf<Jurisdiction>(x => x.addedToMySite)];
    const surveySearchfields = [nameOf<SampleSurvey>(x => x.name), nameOf<SampleSurvey>(x => x.surveyCode), nameOf<SampleSurvey>(x => x.surveyTypeName)];

    let sampleFields: FormField[] = sectionVisibility([
      new LabelFormField({ property: 'sampleField', name: 'Sample Information', cssClass: "pb-2 text-bold", columnSpan: new ColumnSpan(1, 1) }),
      new SingleSelectionFormField({
        isVisible: isVisibleOnly([airPersonal, noisePersonal, wipePersonal, biologicalPersonal, psychologicalPersonal]), required: true,
        property: nameOf<Sample>(x => x.segId), name: "SEG", options: this.segs, columnSpan: new ColumnSpan(1, 3),
        searchKeys: segSearchfields,
        selectionTemplate: (opt: FormField) => {
          const value = opt.options.find(res => res.id == this.entity[opt.property]) as SEG;
          return value ? `${value.name}${value.code ? ` (${value.code})` : ''}` : '-';
        },
        onChange: () => this.loadSegShiftValues(),
        optionTemplateFields: segSearchfields,
        optionTemplateLabelMap: { name: 'Name', code: 'Code', addedToMySite: '' },
        optionTemplateBadgeFields: [nameOf<SEG>(x => x.addedToMySite)],
        searchComponent: SegListComponent
      }),
      new TextFormField({ property: nameOf<Sample>(x => x.sampleNumber), name: "Sample Number", columnSpan: new ColumnSpan(1, 3), required: true, }),
      new TextFormField({ property: nameOf<Sample>(x => x.alternateSampleNumber), name: "Alternate Sample Number", columnSpan: new ColumnSpan(1, 3), required: false }),
      new SingleSelectionFormField({
        onChange: (event, field) => { this.entity[field.property] = event.value; this.getBlankSamples() },
        property: nameOf<Sample>(x => x.sampleSurveyId), name: "Survey Name", options: this.sampleSurveys, columnSpan: new ColumnSpan(1, 3), required: false,
        selectionTemplate: (opt: FormField) => {
          const value = opt.options.find(res => res.id == this.entity[opt.property]) as SampleSurvey;
          return value ? `${value.name}${value.surveyCode ? ` (${value.surveyCode})` : ''}` : '';
        },
        optionTemplateFields: surveySearchfields,
        optionTemplateLabelMap: { name: 'Name', surveyCode: 'Survey Code', surveyTypeName: 'Survey Type Name' },
        searchKeys: surveySearchfields,
        searchComponent: SurveyListComponent
      }),
      new HierarchicalSelectionFormField({
        property: nameOf<Sample>(x => x.organizationLevelId), name: "Organization Level", columnSpan: new ColumnSpan(1, 3),
        options: toOrganizationTree(this.organizationLevels), isVisible: () => this.entity.sampleCategory === SampleCategoryEnum.Blank,
      }),
      new SingleSelectionFormField({
        isVisible: isVisibleOnly([airPersonal, airArea]), required: false, options: [], readonly: true,
        property: nameOf<Sample>(x => x.blankSampleId), name: "Blank Id", columnSpan: new ColumnSpan(1, 3),
        searchComponent: SampleListComponent,
      }),
      new SingleSelectionFormField({
        isVisible: isVisibleExcept([wipeArea, airBlank, wipePersonal, biologicalPersonal]), options: getEnumLookup(SampleShiftCoverage),
        property: nameOf<Sample>(x => x.shiftType), name: 'Coverage', columnSpan: new ColumnSpan(1, 3)
      }),
      new SingleSelectionFormField({
        isVisible: isVisibleExcept([airBlank]), required: false,
        property: nameOf<Sample>(x => x.managingHygienistId), name: 'Managing Hygienist', options: this.users, columnSpan: new ColumnSpan(1, 3),
        searchComponent: UserListComponent
      }),
      new SingleSelectionFormField({
        isVisible: isVisibleExcept([airBlank]), required: false,
        property: nameOf<Sample>(x => x.sampledByUserId), name: 'Sampled By', options: this.users, columnSpan: new ColumnSpan(1, 3),
        searchComponent: UserListComponent
      }),
      new SingleSelectionFormField({
        isVisible: isVisibleExcept([wipeArea, airBlank, biologicalPersonal]),
        property: nameOf<Sample>(x => x.unsampledTimeCorrection), name: "Unsampled Time Correction", options: getEnumLookup(UnsampledTimeCorrectionType), columnSpan: new ColumnSpan(1, 3)
      }),
      new SingleSelectionFormField({
        isVisible: isVisibleOnly([noisePersonal]), required: false, property: 'noiseType', name: "Noise Type", options: getEnumLookup(NoiseSpeedType), columnSpan: new ColumnSpan(1, 3)
      }),
      new DateTimeFormField({ isVisible: isVisibleOnly([airPersonal, airArea, noisePersonal, noiseArea, airBlank, wipeBlank, wipeArea, wipePersonal, biologicalPersonal, psychologicalPersonal]), property: nameOf<Sample>(x => x.startDate), name: "Date and Time of Sampling", cssClass: "date-assign", columnSpan: new ColumnSpan(1, 3), onChange: (value: Date | string) => this.onStartDateChange(value) }),
      new TimeFormField({ isVisible: isVisibleOnly([airPersonal, airArea, noisePersonal, noiseArea]), property: nameOf<Sample>(x => x.endDate), name: "End Time", columnSpan: new ColumnSpan(1, 3) }),
      new LabelFormField({ property: 'dayAhead', name: '+1 day', cssClass: "day-ahead", columnSpan: new ColumnSpan(2, 3), isVisible: () => {
        if (!this.entity.startDate || !this.entity.endDate) return false;
        const startLocal = this.entity.startDate instanceof Date
          ? this.entity.startDate
          : this.dateFormatService.convertStringToDate(this.entity.startDate as string);
        const startTime = this.dateFormatService.formatDateTimeToString(startLocal, this.dateFormatService.canonicalTimeFormat);
        return this.entity.endDate < startTime;
      }}),
      /* agent section */
      new LabelFormField({ property: 'agentsField', name: 'Agents', cssClass: "pb-2 text-bold section-divider", columnSpan: new ColumnSpan(1, 1) }),
      new RadioFormField({
        property: nameOf<Sample>(x => x.selectedBy), cssClass: 'agents-radio', name: "", required: false, options: sampleOptions,
        columnSpan: new ColumnSpan(1, 1), onChange: (sample: Sample) => { this.useAgentGroups = Boolean(sample); this.updateAgentRadio() }
      }),
      new MultiSelectionFormField({
        isVisible: () => this.useAgentGroups === false,
        property: nameOf<Sample>(x => x.agentIds), name: "Sampled Agents", required: true, options: this.agents, columnSpan: new ColumnSpan(1, 3),
        searchKeys: agentSearchfields, onChange: () => { this.updateAgent() },
        selectionTemplate: (opt: FormField) =>
          (opt.options as Agent[]).filter(res => this.entity[opt.property]?.includes(res.id))
            .map((res) => `${res.name}${res.casId ? ` (${res.casId})` : ''}`).join(', '),
        optionTemplateFields: agentSearchfields,
        optionTemplateLabelMap: { name: 'Name', casId: 'Code', addedToMySite: '' },
        optionTemplateBadgeFields: [nameOf<Agent>(x => x.addedToMySite)],
        searchComponent: AgentsListComponent
      }),
      new SingleSelectionFormField({
        isVisible: () => this.useAgentGroups === true,
        property: nameOf<Sample>(x => x.agentGroupId), name: "Sampled Agent Groups", required: true, options: this.agentGroups, columnSpan: new ColumnSpan(1, 3),
        searchKeys: agentGroupSearchfields, onChange: () => { this.updateAgent(); this.getGroupAgents(); },
        selectionTemplate: (opt: FormField) => {
          const value = opt.options.find(res => res.id == this.entity[opt.property]) as AgentGroup;
          return value ? `${value.name}${value.casId ? ` (${value.casId})` : ''}` : '';
        },
        optionTemplateFields: agentGroupSearchfields,
        optionTemplateLabelMap: { name: 'Name', casId: 'Code', addedToMySite: '' },
        optionTemplateBadgeFields: [nameOf<AgentGroup>(x => x.addedToMySite)],
        searchComponent: AgentGroupListComponent
      }),
      new MultiSelectionFormField({
        property: nameOf<Sample>(x => x.jurisdictionIds), name: "Select jurisdictions", required: true, options: this.jurisdictions, columnSpan: new ColumnSpan(1, 3),
        searchKeys: jurisdictionSearchfields, readonly: true, onChange: () => this.updateJurisdiction(),
        selectionTemplate: (opt: FormField) => `${opt.options
          .filter(res => this.entity[opt.property]?.includes(res.id)).map(res => res.name).join(', ')}`,
        optionTemplateFields: jurisdictionSearchfields,
        optionTemplateLabelMap: { name: 'Name', addedToMySite: '' },
        optionTemplateBadgeFields: [nameOf<Jurisdiction>(x => x.addedToMySite)],
        searchComponent: JurisdictionsListComponent
      }),
      new SingleSelectionFormField({
        property: nameOf<Sample>(x => x.oelTypeId), name: "OEL Type", options: this.oelTypes, columnSpan: new ColumnSpan(1, 3), readonly: true,
        searchComponent: OelTypeComponent, required: !(this.entity.sampleCategory === SampleCategoryEnum.Blank)
      }),
      new MultiSelectionFormField({
        property: 'selectedGroupAgents', name: "Group's Agents", required: false, options: this.groupAgents,
        columnSpan: new ColumnSpan(1, 3), cssClass: 'chip-items', readonly: true,
        isVisible: (sample) => this.useAgentGroups && !!sample.agentGroupId && (this.groupAgents?.length > 0 || this.entity.agentIds?.length > 0),
        selectionTemplate: (opt: FormField) => {
          const html = (opt.options as Agent[]).map((res) =>
            `<li class="chip">${res.name}${res.casId ? ` (${res.casId})` : ''}</li>`).join('');
          return `<ul class="chip-list">${html}</ul>`;
        }
      }),
      new LabelFormField({
        property: '', name: '', columnSpan: new ColumnSpan(1, 3), required: false,
        isVisible: (sample) => this.useAgentGroups && !!sample.agentGroupId && (this.groupAgents?.length > 0 || this.entity.agentIds?.length > 0),
      }),
      new LabelFormField({
        property: '', name: '', columnSpan: new ColumnSpan(2, 3), required: false,
        isVisible: (sample) => !(this.useAgentGroups && !!sample.agentGroupId && (this.groupAgents?.length > 0 || this.entity.agentIds?.length > 0)),
      }),
      new LabelFormField({
        property: '', name: '', columnSpan: new ColumnSpan(1, 3), required: false,
        isVisible: (sample) => (sample.sampleCategory === SampleCategoryEnum.Blank)
      }),
      new CheckboxFormField({
        property: nameOf<Sample>(x => x.applyShiftCorrection), name: "Apply Shift Correction",
        required: false, columnSpan: new ColumnSpan(1, 3), cssClass: 'mt-n4 ml-n2',
        onChange: () => this.applyShiftCorrectionChanges(), isVisible: (sample) => !(sample.sampleCategory === SampleCategoryEnum.Blank) && sample.sampleType !== SampleTypeEnum.Biological
      }),
      new LabelFormField({
        property: 'adHoc', name: "Would you like to add more Agents?", columnSpan: new ColumnSpan(1, 3), required: false,
        isVisible: (sample) => this.useAgentGroups && !!sample.agentGroupId,
      }),
      new LabelFormField({
        property: '', name: '', columnSpan: new ColumnSpan(2, 3), required: false,
        isVisible: (sample) => this.useAgentGroups && !!sample.agentGroupId
      }),
      new MultiSelectionFormField({
        property: nameOf<Sample>(x => x.agentIds), name: "Sample Agents", required: false, options: this.agents, columnSpan: new ColumnSpan(1, 3),
        searchKeys: agentSearchfields, onChange: () => { this.updateAgent(false, true) },
        selectionTemplate: (opt: FormField) =>
          (opt.options as Agent[]).filter(res => this.entity[opt.property]?.includes(res.id))
            .map((res) => `${res.name}${res.casId ? ` (${res.casId})` : ''}`).join(', '),
        optionTemplateFields: agentSearchfields,
        optionTemplateLabelMap: { name: 'Name', casId: 'Code', addedToMySite: '' },
        optionTemplateBadgeFields: [nameOf<Agent>(x => x.addedToMySite)],
        searchComponent: AgentsListComponent,
        isVisible: (sample) => this.useAgentGroups && !!sample.agentGroupId
      }),
    ], commonIsVisible);

    const samplingEquipmentSearchfields = [nameOf<SamplingEquipment>(x => x.equipmentCode), nameOf<SamplingEquipment>(x => x.modelNumber), nameOf<SamplingEquipment>(x => x.serialNumber)];
    const calibrationEquipmentSearchfields = [nameOf<CalibrationEquipment>(x => x.equipmentCode), nameOf<CalibrationEquipment>(x => x.modelNumber), nameOf<CalibrationEquipment>(x => x.serialNumber)];

    let mediaEquipmentFields: FormField[] = sectionVisibility([
      new SingleSelectionFormField({
        isVisible: hideAirEquipment, searchComponent: SamplingEquipmentComponent, options: this.samplingEquipments,
        property: nameOf<Sample>(x => x.samplingEquipmentId), name: "Sampling Equipment ID", required: false, columnSpan: new ColumnSpan(1, 3),
        searchKeys: samplingEquipmentSearchfields,
        selectionTemplate: (opt: FormField) => {
          const value = opt.options.find(res => res.id == this.entity[opt.property]) as SamplingEquipment;
          return value ? `${value.equipmentCode ?? '-'}${value.modelNumber ? ` (${value.modelNumber})` : ''}` : '';
        },
        optionTemplateFields: samplingEquipmentSearchfields,
        optionTemplateLabelMap: { equipmentCode: 'Equipment Code', modelNumber: 'Model Number', serialNumber: 'Serial Number' },
      }),
      new SingleSelectionFormField({
        isVisible: hideAirEquipment, searchComponent: CalibrationEquipmentComponent,
        property: nameOf<Sample>(x => x.calibrationEquipmentId), name: "Calibration Equipment ID", required: false,
        options: this.calibrationEquipments, columnSpan: new ColumnSpan(1, 3), searchKeys: calibrationEquipmentSearchfields,
        selectionTemplate: (opt: FormField) => {
          const value = opt.options.find(res => res.id == this.entity[opt.property]) as CalibrationEquipment;
          return value ? `${value.equipmentCode ?? '-'}${value.modelNumber ? ` (${value.modelNumber})` : ''}` : '';
        },
        optionTemplateFields: calibrationEquipmentSearchfields,
        optionTemplateLabelMap: { equipmentCode: 'Equipment Code', modelNumber: 'Model Number', serialNumber: 'Serial Number' },
      }),
      new SingleSelectionFormField({
        isVisible: hideAirEquipment,
        property: nameOf<Sample>(x => x.sensorId), name: "Sensor Id", options: this.sensors,
        columnSpan: new ColumnSpan(1, 3), required: false
      }),
      new NumberFormField({
        isVisible: hideAirEquipment,
        property: nameOf<Sample>(x => x.samplePreCal), name: 'Initial Flow Rate', additionalLabel: () => flowRateUnit, required: false, columnSpan: new ColumnSpan(1, 3), min: 0
      }),
      new NumberFormField({
        isVisible: hideAirEquipment,
        property: nameOf<Sample>(x => x.samplePostCal), name: 'Final Flow Rate', additionalLabel: () => flowRateUnit, required: false, columnSpan: new ColumnSpan(1, 3), min: 0
      }),
      new LabelFormField({ name: '', property: 'empty', required: false, columnSpan: new ColumnSpan(1, 3), isVisible: isVisibleExcept([noisePersonal, wipeArea, airBlank, wipeBlank]) }),
      new SingleSelectionFormField({
        isVisible: isVisibleExcept([noisePersonal]), required: false,
        property: nameOf<Sample>(x => x.sampleMediaId), name: "Sample Media", options: this.sampleMediaList, columnSpan: new ColumnSpan(1, 3)
      }),
      new TextFormField({
        isVisible: isVisibleExcept([noisePersonal, biologicalPersonal]), required: false,
        property: nameOf<Sample>(x => x.mediaLotNumber), name: "Media Lot Number", columnSpan: new ColumnSpan(1, 3)
      }),
    ], commonIsVisible);

    const employeeSearchKeys = this.customObjectsList?.map(obj => obj.property);
    let employeeFields: FormField[] = sectionVisibility([
      new SingleSelectionFormField({
        cssClass: 'custom-search-employee',
        property: 'search_employee', name: "Search Employee", options: this.employees, columnSpan: new ColumnSpan(5, 6),
        onChange: (event: any, field: FormField) => this.onSelectionChange(event, field),
        searchKeys: employeeSearchKeys,
        onSearchChange: (event: any, field: FormField) => { this.searchEntities(event, field) },
        selectionTemplate: (opt: FormField) => {
          const property = opt.options.find(res => res.id == this.entity[opt.property]);
          return property?.name;
        },
        optionTemplateFields: [
          nameOf<CustomEntity>(x => x.name),
          nameOf<CustomEntity>(x => x.organizationLevelName),
        ],
        optionTemplateLabelMap: { ...EMPLOYEE_BASE_LABEL_MAP },
        required: false,
        searchComponent: EndpointsTableComponent, additonalSearchData: { coId: this.coId }
      }),
      new LabelFormField({
        property: '', name: '', columnSpan: new ColumnSpan(1, 6), cssClass: 'add-employee', iconClass: 'fa fa-user-plus',
        onClick: () => this.customEntityLoaderService.openEntityDialog(CustomObjectTypeEnum.EmployeeEndPoint, this.coId, () => this.getCustomEntities()), required: false
      })
    ], isVisibleOnly([airPersonal, noisePersonal, wipePersonal, biologicalPersonal, psychologicalPersonal]));

    let controlFields: FormField[] = sectionVisibility([
      new MultiSelectionFormField({
        property: nameOf<Sample>(x => x.ppeAssignmentList), name: "PPE", options: this.ppeList,
        isVisible: isVisibleOnly([airPersonal, noisePersonal]), columnSpan: new ColumnSpan(1, 3), required: false,
        searchComponent: PpeListComponent
      }),
      new MultiSelectionFormField({
        required: false, readonly: true, isVisible: isVisibleOnly([airPersonal, noisePersonal]),
        property: nameOf<Sample>(x => x.analyticalMethodId/* to change, once implemented */), name: "Process and Controls", options: [], columnSpan: new ColumnSpan(1, 3)
      }),
    ], commonIsVisible);

    let locationFields: FormField[] = sectionVisibility([
      new SingleSelectionFormField({
        options: this.locations,
        property: "location", name: "Location", required: false, columnSpan: new ColumnSpan(3, 6),
        onChange: (event: any, field: FormField) => this.onSelectionChange(event, field),
      }),
      new LabelFormField({
        property: '', name: '', columnSpan: new ColumnSpan(1, 6), cssClass: 'add-employee', iconClass: 'fa fa-plus',
        onClick: () => this.customEntityLoaderService.openEntityDialog(CustomObjectTypeEnum.LocationEndPoint, this.coId, () => this.getCustomEntities()), required: false,
      }),
      new TextFormField({
        property: "locationComments", name: "Location Comments", required: false, columnSpan: new ColumnSpan(2, 6)
      }),
      new HierarchicalSelectionFormField({
        property: nameOf<Sample>(x => x.organizationLevelId), name: "Organization Level",
        options: toOrganizationTree(this.organizationLevels), columnSpan: new ColumnSpan(1, 3),
      }),
      new NumberFormField({
        property: nameOf<Sample>(x => x.shiftLength), name: "Shift Length [hours]", min: 1, max: 24,
        required: this.entity.applyShiftCorrection, isVisible: isVisibleOnly([airArea, noiseArea]),
        onChange: (event: any, field: FormField) => this.onShiftLengthInputChange(event, field), columnSpan: new ColumnSpan(1, 3)
      }),
      new NumberFormField({
        property: nameOf<Sample>(x => x.averageWeeklyHours_Seconds), name: "Avg Weekly Hours", min: 1, columnSpan: new ColumnSpan(1, 3),
        required: this.entity.applyShiftCorrection, isVisible: isVisibleOnly([airArea, noiseArea]),
      }),
      new SingleSelectionFormField({
        property: nameOf<Sample>(x => x.shiftRoster), name: "Shift Roster",
        options: getEnumLookup(ShiftType).map(res => ({ id: res.id, name: res.name.replace(/_/g, ' ') })),
        columnSpan: new ColumnSpan(1, 3), required: false, isVisible: isVisibleOnly([airArea, noiseArea]),
      }),
      new SingleSelectionFormField({
        property: nameOf<Sample>(x => x.shiftId), name: "Shift Selector",
        options: this.shifts.map(shift => ({ id: shift.id, name: shift.name || '' })),
        onChange: (event: any) => { this.entity.shiftId = event.value; },
        columnSpan: new ColumnSpan(1, 3), required: false
      })
    ], isVisibleOnly([airArea, noiseArea, wipeArea, wipeBlank]));

    let areaFields: FormField[] = sectionVisibility([
      new RadioFormField({
        property: "lengthUnit", name: "Units", required: false,
        columnSpan: new ColumnSpan(2, 6), cssClass: 'pt-3 d-flex align-items-center',
        options: getEnumLookup(LengthUnit),
      }),
      new NumberFormField({
        property: "length", name: "Length", required: false, columnSpan: new ColumnSpan(2, 6), min: 0,
        onChange: () => this.updateDimensionFields()
      }),
      new NumberFormField({
        property: "width", name: "Width", required: false, columnSpan: new ColumnSpan(2, 6), min: 0,
        onChange: () => this.updateDimensionFields()
      }),
      new RadioFormField({
        property: "lengthUnit", name: "Units", required: false,
        columnSpan: new ColumnSpan(2, 6), cssClass: 'pt-3 d-flex align-items-center',
        options: getEnumLookup(AreaUnit),
      }),
      new NumberFormField({
        property: "area", name: "Area", required: false, columnSpan: new ColumnSpan(2, 6), min: 0,
        onChange: () => this.updateDimensionFields()
      }),
    ], isVisibleOnly([wipeArea, wipeBlank, wipePersonal]));

    const temperatureUnit = this.valueConversionService.getParameterUnit(ParameterTypeEnum.Temperature);
    let weatherInformationFields: FormField[] = sectionVisibility([
      new NumberFormField({
        property: nameOf<Sample>(x => x.temperatureMaxC), name: "Max Temp", required: false, columnSpan: new ColumnSpan(1, 6),
        additionalLabel: () => '(' + temperatureUnit + ')'
      }),
      new NumberFormField({
        property: nameOf<Sample>(x => x.temperatureMinC), name: "Min Temp", required: false, columnSpan: new ColumnSpan(1, 6),
        additionalLabel: () => '(' + temperatureUnit + ')'
      }),
      new NumberFormField({
        property: nameOf<Sample>(x => x.humidityPercent), name: "Humidity", required: false, columnSpan: new ColumnSpan(1, 3), min: 0, max: 100
      }),
      new NumberFormField({
        property: nameOf<Sample>(x => x.pressureMmhg), name: "Pressure", required: false, columnSpan: new ColumnSpan(1, 3), min: 0
      }),
      new SingleSelectionFormField({
        property: nameOf<Sample>(x => x.weatherCondition), name: "Weather Condition", required: false, columnSpan: new ColumnSpan(1, 3),
        options: getEnumLookup(WeatherConditionType)
      }),
      new LabelFormField({ property: '', name: '', columnSpan: new ColumnSpan(1, 3), required: false, }),
      new CheckboxFormField({
        property: nameOf<Sample>(x => x.applyPressureCorrection), name: "Apply Pressure Correction",
        required: false, columnSpan: new ColumnSpan(1, 3), cssClass: 'mt-n4 ml-n2',
        onChange: () => this.applyPressureCorrectionChanges()
      })
    ], isVisibleOnly([airPersonal, airArea]));

    let additionalDetailsFields: FormField[] = sectionVisibility([
      // --- Summary & Attachments (top) ---
      new TextAreaFormField({ property: nameOf<Sample>(x => x.summaryNote), name: "Summary Note", required: false, columnSpan: new ColumnSpan(1, 2) }),
      new FileAttachmentsField({
        property: nameOf<Sample>(x => x.fileAttachmentIds), name: 'Attached  Files', columnSpan: new ColumnSpan(1, 2), options: this.attachedFiles,
        onClick: (id) => this.updateAttachment(id), additionalLabel: () => this.translateService.getDynamicTranslation('+ Add Attachment (up to 5) :'), required: false
      }),
      // --- Exposure & Symptom Assessment (Personal samples only) ---
      new RadioFormField({
        property: nameOf<Sample>(x => x.exposureTypicality),
        name: "Exposure Typicality",
        columnSpan: new ColumnSpan(1, 2),
        cssClass: 'pt-3',
        options: getEnumLookup(ExposureTypicality).sort((a, b) => [2, 0, 1].indexOf(a.id) - [2, 0, 1].indexOf(b.id)),
        isVisible: isVisibleOnly([airPersonal, noisePersonal, wipePersonal, biologicalPersonal, psychologicalPersonal]),
      }),
      new SingleSelectionFormField({
        property: nameOf<Sample>(x => x.overtimeFrequency),
        name: 'Overtime Frequency',
        options: getEnumLookup(OvertimeFrequencyEnum),
        columnSpan: new ColumnSpan(1, 2),
        required: false,
        isVisible: isVisibleOnly([airPersonal, noisePersonal, wipePersonal, biologicalPersonal, psychologicalPersonal]),
      }),
      new TextAreaFormField({
        property: nameOf<Sample>(x => x.exposureAtypicalComments),
        name: "Exposure Atypical Comments",
        required: true,
        columnSpan: new ColumnSpan(1, 1),
        isVisible: (sample) => isVisibleOnly([airPersonal, noisePersonal, wipePersonal, biologicalPersonal, psychologicalPersonal])(sample) && sample.exposureTypicality != null && sample.exposureTypicality !== ExposureTypicality.Typical,
      }),
      new RadioFormField({
        property: nameOf<Sample>(x => x.symptoms),
        name: 'Were symptoms reported?',
        options: [{ id: true, name: 'Yes' }, { id: false, name: 'No' }] as any[],
        columnSpan: new ColumnSpan(1, 2),
        required: false,
        isVisible: isVisibleOnly([airPersonal, noisePersonal, wipePersonal, biologicalPersonal, psychologicalPersonal]),
      }),
      new TextAreaFormField({
        property: nameOf<Sample>(x => x.symptomComments),
        name: 'Symptom Comments',
        required: true,
        isVisible: (sample) => isVisibleOnly([airPersonal, noisePersonal, wipePersonal, biologicalPersonal, psychologicalPersonal])(sample) && sample.symptoms,
        columnSpan: new ColumnSpan(1, 2)
      }),
    ], isVisibleExcept([airBlank]));

    const orgOptions = this.organizationLevels.filter(org => org.orgLevelType === OrgLevelTypeEnum.Site);
    this.initialFields = [
      new SingleSelectionFormField({ property: nameOf<Sample>(x => x.sampleType), name: "Sample Type", options: getSelectableSampleTypes(this.entity?.sampleType), columnSpan: new ColumnSpan(1, 3), onChange: (event) => { if (event.value != null) { this.fieldChanges(); this.updateFlowFields(); this.onSampleTypeChanged(); this.loadAvailableTemplates(); } } }),
      new SingleSelectionFormField({ property: nameOf<Sample>(x => x.sampleCategory), name: "Sample Category", options: getEnumLookup(SampleCategoryEnum), columnSpan: new ColumnSpan(1, 3), onChange: () => this.onSampleCategoryChanged() }),
      new SingleSelectionFormField({
        required: true, onChange: () => { this.updateUserOptions(); this.fieldChanges(); this.getSiteInfo(); },
        property: nameOf<Sample>(x => x.organizationLevelId), name: "Sampling Site", options: orgOptions, columnSpan: new ColumnSpan(1, 3),
        isVisible: () => this.selectedOrgLevel?.orgLevelType !== OrgLevelTypeEnum.Site
      })
    ]

    const fieldGroups = [this.initialFields, sampleFields, mediaEquipmentFields, areaFields, employeeFields,
      controlFields, locationFields, weatherInformationFields, additionalDetailsFields
    ].map(fields => this.updateColumnDetails(fields));

    [this.initialFields, sampleFields, mediaEquipmentFields, areaFields, employeeFields, controlFields,
      locationFields, weatherInformationFields, additionalDetailsFields] = fieldGroups;

    this.fields = fieldGroups.flat();

    this.initialFieldProps = new Map(this.fields
      .filter(field => !!field.property)
      .map(field => [field.property, { ...{ required: field.required !== false } }]));

    if (this.entity.sampleSurveyId) this.getBlankSamples();

    this.stepperConfig = {
      orientation: 'horizontal',
      linear: false,
      steps: [
      this.createSampleStep('sampling', 'Sample Information', sampleFields),
      this.createSampleStep('media', 'Media and Equipment', mediaEquipmentFields),
      this.createSampleStep('area', 'Area', areaFields),
      this.createSampleStep('employee', 'Employee Details', employeeFields),
      this.createSampleStep('controlFields', 'Controls', controlFields),
      this.createSampleStep('location', 'Location', locationFields),
      this.createSampleStep('weatherInfo', 'Weather Information', weatherInformationFields),
      this.createSampleStep('additionalDetails', 'Additional Notes', additionalDetailsFields, { hasNext: false })
      ]
    }

    if (!this.isAdd) {
      this.showStepper();
      this.updateAgentRadio(true);
      this.updateFlowFields();
      this.updateSurveyField();
      this.updateDimensionFields();
    }
    this.updateUserOptions();
    // DASH-2629: apply the biological label/option swap on the edit-existing path too. onSampleTypeChanged()
    // runs from initModel() before the fields exist (no-op), so re-apply here now that this.fields is built.
    this.updateBiologicalFieldPresentation();
  }

  applyShiftCorrectionChanges() {
    this.formFieldService.applyShiftCorrectionChanges(this.entity, this.fields);
    if (this.employeeFields?.length) {
      this.formFieldService.applyShiftCorrectionChanges(this.entity, this.employeeFields);
    }
  }

  applyPressureCorrectionChanges() {
    this.formFieldService.applyPressureCorrectionChanges(this.entity, this.fields);
  }

  getSiteInfo() {
    this.agentJurisdictionLoaderService.getSiteInfo(this.entity).subscribe();
  }

  updateSurveyField() {
    const survey = this.sampleSurveys.find(survey => survey.id === this.entity.sampleSurveyId);
    if (!survey && this.entity.sampleSurveyId) {
      this.sampleSurveyService.getById(this.entity.sampleSurveyId).subscribe({
        next: (response) => {
          const surveyField = this.fields.find(field => field.property === nameOf<Sample>(x => x.sampleSurveyId));
          this.sampleSurveys = [...this.sampleSurveys, response];
          surveyField.options = this.sampleSurveys;
        },
        error: (error) => {
          this.toastService.showError(error);
        }
      });
    }
  }

  getGroupAgents() {
    if (!this.entity.agentGroupId) {
      this.updateField(nameOf<Sample>(x => x.agentIds) as string, this.agents);
      this.updateField('selectedGroupAgents', []);
      return;
    }
    this.agentGroupService.getById(this.entity.agentGroupId).subscribe({
      next: (res: AgentGroup) => {
        const agentIds = res?.agentIds ?? [];
        this.entity.agentIds = [];

        if (!agentIds.length) {
          this.groupAgents = [];
          this.updateField(nameOf<Sample>(x => x.agentIds), this.agents);
          this.updateField('selectedGroupAgents', []);
          return;
        }

        const agentPayload = {
          OperatorTypeEnum: JSON.stringify({
            Condition: OperatorTypeEnum.Equal,
            Field: 'id',
            Value: (res?.agentIds || []).join(', ')
          })
        };
        this.agentService.getAll(JSON.stringify(agentPayload)).subscribe((agents: Lookup[]) => {
          this.groupAgents = agents;
          const remainingAgents = this.agents.filter(agent => !this.groupAgents.some(g => g.id === agent.id));
          this.updateField(nameOf<Sample>(x => x.agentIds), remainingAgents);

          this.entity['selectedGroupAgents'] = this.groupAgents.map(agent => String(agent.id));
          this.updateField('selectedGroupAgents', this.groupAgents);
        });
      }
    });
  }

  getBlankSamples() {
    const bf = this.fields?.find(f => f?.property === nameOf<Sample>(x => x.blankSampleId));
    if (!bf) {
      return;
    }
    const isBlankFieldVisible = isVisibleOnly([
      SampleTypeCategoryCombos.airArea,
      SampleTypeCategoryCombos.airPersonal
    ])(this.entity);

    bf.searchComponent = isBlankFieldVisible ? SampleListComponent : null;
    bf.additonalSearchData = isBlankFieldVisible
      ? { additionalFilters: this.getBlankSampleSearchFilters() }
      : null;

    if (isBlankFieldVisible && this.entity.sampleSurveyId) {
      bf.readonly = false;
      this.sampleService.getAll(JSON.stringify({
        sampleSurveyId: this.entity.sampleSurveyId,
        sampleCategory: SampleCategoryEnum.Blank
      })).subscribe(r => {
        bf.options = sortBlankSamplesDescending(r);
      });
    } else if (isBlankFieldVisible) {
      bf.readonly = false;
      bf.options = [];
      this.entity.blankSampleId = null;
    } else {
      bf.readonly = true;
      bf.options = [];
      this.entity.blankSampleId = null;
    }
  }

  private getBlankSampleSearchFilters(): Record<string, string | number | boolean> {
    const filters: Record<string, string | number | boolean> = {
      sampleCategory: SampleCategoryEnum.Blank
    };

    if (this.entity.sampleSurveyId) {
      filters.sampleSurveyId = this.entity.sampleSurveyId;
    }

    const organizationLevelId = this.selectedOrgLevel?.id ?? this.entity.organizationLevelId;
    if (organizationLevelId != null) {
      filters.organizationLevelId = organizationLevelId;
    }

    return filters;
  }

  updateAttachment(id: any) {
    if (id === 0) {
      this.openAttachmentForm();
    } else {
      this.entity.fileAttachmentIds = this.entity.fileAttachmentIds.filter(a => a !== id);
      this.attachedFiles = this.attachedFiles.filter(a => a.id !== id);
      const field = this.fields.find(f => f?.property === nameOf<Sample>(x => x.fileAttachmentIds));
      if (field) {
        field.options = this.attachedFiles;
      }
    }
  }

  updatePpe(missingIds: string[] = []) {
    this.updatePpe$(missingIds).subscribe();
  }

  private updatePpe$(missingIds: string[] = []): Observable<void> {
    const f = missingIds?.length
      ? { OperatorTypeEnum: JSON.stringify({ Condition: OperatorTypeEnum.Equal, Field: 'id', Value: missingIds.join(', ') }) }
      : { type: this.entity.sampleType };

    return this.ppeService.getAll(JSON.stringify(f)).pipe(
      switchMap(p => {
        if (!missingIds?.length) {
          const m = (this.entity.ppeAssignmentList ?? []).filter(id => !p.some(x => x.id === id));
          if (m.length) {
            this.ppeList = p;
            return this.updatePpe$(m);
          }
        }
        this.ppeList = missingIds?.length ? [...p, ...this.ppeList] : p;
        this.updateField(nameOf<Sample>(x => x.ppeAssignmentList) as string, this.ppeList);
        return of(undefined);
      })
    );
  }

  onSampleTypeChanged() {
    // DASH-2621: Biological and Other are Personal-only sample types. Force the category to
    // Personal so the (type, category) field-visibility mappings resolve and the dialog stays coherent.
    if (this.entity?.sampleType === SampleTypeEnum.Biological || this.entity?.sampleType === SampleTypeEnum.Other) {
      this.entity.sampleCategory = SampleCategoryEnum.Personal;
    }
    this.updatePpe(); this.updateAgentsList(); this.updateSamplingEquipmentList();
    this.sampleStatusList = getFilteredSampleStatuses(getEnumLookup(SampleStatusEnum), this.entity?.sampleType, this.entity?.sampleCategory, this.entity?.sampleStatus);
    this.getBlankSamples();
    this.applyDefaultEndTime();
    this.updateBiologicalFieldPresentation();
  }

  // DASH-2740: a biological sample uses the same unfiltered Media dropdown as an air sample (one shared
  // media catalogue, no per-type filtering). Only the date/time labels vary here.
  private updateBiologicalFieldPresentation(): void {
    const isBio = this.entity?.sampleType === SampleTypeEnum.Biological;

    const startDateField = this.fields?.find(f => f.property === nameOf<Sample>(x => x.startDate));
    if (startDateField) startDateField.name = isBio ? 'Date/Time of Collection' : 'Date and Time of Sampling';

    const endDateField = this.fields?.find(f => f.property === nameOf<Sample>(x => x.endDate));
    if (endDateField) endDateField.name = 'End Time';
  }

  private onSampleCategoryChanged(): void {
    this.fieldChanges(); this.sampleStatusList = getFilteredSampleStatuses(getEnumLookup(SampleStatusEnum), this.entity?.sampleType, this.entity?.sampleCategory, this.entity?.sampleStatus);
    this.getBlankSamples();
    this.applyDefaultEndTime();
    this.loadAvailableTemplates();
  }

  updateSamplingEquipmentList() {
    this.updateSamplingEquipmentList$().subscribe();
  }

  private updateSamplingEquipmentList$(): Observable<void> {
    const f = JSON.stringify({ organizationLevelId: this.selectedOrgLevel?.id ?? this.entity.organizationLevelId, sampleType: this.entity.sampleType });
    return this.samplingEquipmentService.getAll(f).pipe(
      switchMap(eq => {
        if (this.entity.samplingEquipmentId != null && !eq.some(e => e.id === this.entity.samplingEquipmentId)) {
          const mf = JSON.stringify({ OperatorTypeEnum: JSON.stringify({ Condition: OperatorTypeEnum.Equal, Field: 'id', Value: String(this.entity.samplingEquipmentId) }) });
          return this.samplingEquipmentService.getAll(mf).pipe(map(m => !m.length ? eq : [...eq, ...m]));
        }
        return of(eq);
      }),
      tap(eq => { this.samplingEquipments = eq; this.updateField(nameOf<Sample>(x => x.samplingEquipmentId) as string, eq); }),
      map(() => undefined)
    );
  }

  updateAgentsList() {
    this.updateAgentsList$().subscribe();
  }

  private updateAgentsList$(): Observable<void> {
    return this.agentService.getAll(JSON.stringify({
      organizationLevelId: this.selectedOrgLevel?.id ?? this.entity.organizationLevelId,
      agentType: this.entity.sampleType
    })).pipe(
      tap(al => {
        this.agents = al;
        this.updateField(nameOf<Sample>(x => x.agentIds) as string, al);
      }),
      map(() => undefined)
    );
  }

  updateAgentRadio(isInitial = false) {
    if (this.useAgentGroups) {
      this.entity.agentIds = [];
    } else {
      if (this.isAdd) {
        this.entity.agentGroupId = null;
      }
      if (this.agents) {
        this.updateField(nameOf<Sample>(x => x.agentIds) as string, this.agents);
      }
    }

    if (isInitial) {
      this.updateAgent(true, false);
    } else {
      const fieldsToReset = this.entity.sampleCategory === SampleCategoryEnum.Blank
        ? []
        : [nameOf<Sample>(x => x.oelTypeId)];
      [...fieldsToReset, nameOf<Sample>(x => x.jurisdictionIds)].forEach(p => this.updateField(p as string, []));
    }
  }

  updateAgent(isInitial = false, additionalAgents = false, onLoaded?: () => void) {
    const { agentIds, agentGroupId } = this.entity;
    if ((!agentIds?.length && !this.useAgentGroups) || (this.useAgentGroups && !agentGroupId)) {
      this.entity.agentIds = [];
      [...(this.entity.sampleCategory === SampleCategoryEnum.Blank) ? [] : [nameOf<Sample>(x => x.oelTypeId)],
      nameOf<Sample>(x => x.jurisdictionIds)].forEach(property => this.updateField(property, []));
      return;
    }
    if (additionalAgents) {
      const additionalAgentsList = this.agents.filter(agent => this.entity.agentIds.includes(String(agent.id)));
      this.updateField('selectedGroupAgents', [...additionalAgentsList, ...this.groupAgents]);
      this.entity['selectedGroupAgents'] = [...additionalAgentsList, ...this.groupAgents].map(agent => String(agent.id));
    }

    const isAdditional = additionalAgents && this.entity.agentIds?.length > 0;
    if (isInitial && this.useAgentGroups && agentGroupId) this.getGroupAgents();
    const apis = this.useAgentGroups && !isAdditional ? [this.agentJurisdictionService.getAgentGroupDetails(agentGroupId)] : agentIds.map(agentId => this.agentJurisdictionService.getAgentDetails(agentId));
    forkJoin(apis).subscribe({
      next: (responses) => {
        this.jurisdictions = [...(isAdditional ? this.jurisdictions : []), ...responses.flat().filter(item => item.jurisdictionId != null).map(item => {
          const fromAll = this.allJurisdictions.find(x => x.id === item.jurisdictionId);
          return { ...item, ...fromAll };
        })];

        this.oelTypes = [...(isAdditional ? this.oelTypes : []), ...responses.flat().filter(item => item.oelTypeId != null).map(item => {
          return { ...item, id: item.oelTypeId, name: item.oelTypeName };
        })];

        this.updateField(nameOf<Sample>(x => x.jurisdictionIds), this.jurisdictions);
        if (isInitial) {
          if (this.entity.sampleCategory === SampleCategoryEnum.Blank) {
            const oelField = this.fields.find(f => f.property === nameOf<Sample>(x => x.oelTypeId));
            if (oelField) this.setBlankOelType(oelField);
          } else {
            this.updateField(nameOf<Sample>(x => x.oelTypeId), this.oelTypes);
          }
        }
        onLoaded?.();
      },
      error: (err) => { console.error('Error fetching jurisdictions', err); }
    });
  }

  updateJurisdiction() {
    if (this.entity.sampleCategory === SampleCategoryEnum.Blank) return;
    this.updateField(nameOf<Sample>(x => x.oelTypeId) as string, this.oelTypes.filter(o => this.entity.jurisdictionIds?.includes((o as any).jurisdictionId)));
    this.entity.applyPressureCorrection = this.allJurisdictions.filter(j => this.entity.jurisdictionIds?.includes(j.id)).some(j => j.applyPressureCorrection);
    this.applyPressureCorrectionChanges();
  }

  updateField(property: string, list: Lookup[]) {
    const mf = this.fields?.filter(f => f.property === property); if (!mf?.length) return;
    const ul = list.filter((i, idx, s) => idx === s.findIndex(t => t.id === i.id));
    mf.forEach(f => {
      // Fields tagged "linked to my site" only show entries linked to the current site.
      const opts = filterLinkedToMySiteOptions(ul, f.optionTemplateBadgeFields);
      // On Edit, keep any previously-saved option(s) visible in the dropdown so the
      // selectionTemplate can still render the saved value, even if that entity is not
      // linked to the current site (otherwise it would display as blank). This affects
      // display only; new choices stay restricted to site-linked options via `basis`.
      let displayOpts = opts;
      if (!this.isAdd && opts.length !== ul.length) {
        const saved = this.entity[f.property];
        const savedIds = Array.isArray(saved) ? saved : (saved != null ? [saved] : []);
        const preserved = ul.filter(o => savedIds.includes(o.id) && !opts.some(x => x.id === o.id));
        if (preserved.length) displayOpts = [...opts, ...preserved];
      }
      f.options = displayOpts;
      // Anchor the readonly/clear logic to the filtered options only when ADDING a sample
      // (enforce site-linked-only choices for new samples). When EDITING, anchor to the
      // TOTAL options instead: a saved Agent/SEG/Jurisdiction that isn't linked to the
      // current site would otherwise make the field readonly and silently clear the saved
      // association on the next save even though the user never touched it.
      const basis = this.isAdd ? opts : ul;
      if (f.property !== 'selectedGroupAgents') f.readonly = !basis.length;
      if (!basis.length) this.entity[f.property] = f.type === FormFieldType.MultipleSelection ? [] : null;
    });
  }

  fieldChanges() {
    if ([this.entity.sampleType, this.entity.sampleCategory, this.entity.organizationLevelId].some(v => v == null)) return;

    if (this.isAdd && (this.entity.sampleCategory === SampleCategoryEnum.Area || this.entity.sampleCategory === SampleCategoryEnum.Blank)) {
      this.entity.applyShiftCorrection = false;
    }

    for (const field of this.fields) {
      const property = field.property;
      if (!property) continue;
      const isVisible = typeof field.isVisible === 'function' ? field.isVisible(this.entity) : true;
      const originalRequired = this.initialFieldProps.get(property)?.required ?? true;
      field.required = isVisible ? originalRequired : false;
      if (field.property == nameOf<Sample>(x => x.oelTypeId)) {
        const isBlank = this.entity.sampleCategory === SampleCategoryEnum.Blank;
        field.required = !isBlank;
        isBlank && this.setBlankOelType(field);
      }
    }
    this.applyShiftCorrectionChanges();
    this.getCustomEntities();
  }

  setBlankOelType(field?: FormField) {
    const blankName = 'Blank';
    const filterPayload = {
      OperatorTypeEnum: JSON.stringify({
        Condition: OperatorTypeEnum.Equal,
        Field: 'name', Value: blankName
      })
    };
    this.oelTypeService.getAll(JSON.stringify(filterPayload)).subscribe({
      next: (res) => {
        if (res?.length) {
          field.options = res;
          this.entity.oelTypeId = String(res[0].id);
        }
      },
      error: (error) => {
        this.toastService.showError(error);
      }
    })
  }

  updateUserOptions() {
    this.formFieldService.updateUserOptions(this.entity, this.organizationLevels, this.fields);
    this.formFieldService.updateSampleNumberField(this.entity, this.organizationLevels, this.fields);
  }

  createEmployeeFields() {
    this.employeeFields = [];
    const customEntity = this.entity.endPointId ? this.customEntities.find(entity => entity.id === this.entity.endPointId) : null;
    this.customObjectsList.forEach((obj: CustomField) => {
      this.employeeFields.push(new TextFormField({ property: obj.property, name: obj.name, columnSpan: new ColumnSpan(1, 3), readonly: true, required: false }))
      this.entity[obj.property] = customEntity?.[obj.property];
    })
    this.entity['search_employee'] = customEntity?.id;
    this.employeeFields.push(new SingleSelectionFormField({
      property: nameOf<Sample>(x => x.endpointOrganizationLevelId), name: "Employee Organization Level",
      options: this.organizationLevels, columnSpan: new ColumnSpan(1, 3), required: false, readonly: true
    }));
    this.employeeFields.push(new HierarchicalSelectionFormField({
      property: nameOf<Sample>(x => x.organizationLevelId), name: "Sample Organization Level",
      options: toOrganizationTree(this.organizationLevels), columnSpan: new ColumnSpan(1, 3),
      required: true, onChange: () => this.loadSegShiftValues(),
    }));
    this.employeeFields.push(new NumberFormField({
      property: nameOf<Sample>(x => x.shiftLength), name: "Shift Length [hours]", min: 1, max: 24, required: this.entity.applyShiftCorrection,
      onChange: (event: any, field: FormField) => this.onShiftLengthInputChange(event, field), columnSpan: new ColumnSpan(1, 3)
    }));
    this.employeeFields.push(new NumberFormField({
      property: nameOf<Sample>(x => x.averageWeeklyHours_Seconds), name: "Avg Weekly Hours", min: 1, columnSpan: new ColumnSpan(1, 3),
      required: this.entity.applyShiftCorrection
    }));
    this.employeeFields.push(new SingleSelectionFormField({
      property: nameOf<Sample>(x => x.shiftRoster), name: "Shift Roster",
      options: getEnumLookup(ShiftType).map(res => ({ id: res.id, name: res.name.replace(/_/g, ' ') })),
      columnSpan: new ColumnSpan(1, 3), required: false
    }));
    this.employeeFields.push(new SingleSelectionFormField({
      property: nameOf<Sample>(x => x.shiftId), name: "Shift Selector",
      options: this.shifts.map(shift => ({ id: shift.id, name: shift.name || '' })),
      onChange: (event: any) => { this.entity.shiftId = event.value; },
      columnSpan: new ColumnSpan(1, 3), required: false
    }));
    if (this.entity.sampleCategory === SampleCategoryEnum.Personal) {
      this.employeeFields.push(new TextFormField({
        property: "locationComments", name: "Location Comments", required: false, columnSpan: new ColumnSpan(2, 6)
      }))
    }
  }

  searchEntities(filter: string, employeeField: FormField) {
    this.customEntityService.get(filter, 'id', 'asc', 0, DEFAULT_PAGE_SIZE, '', new HttpHeaders({ coid: this.coId }))
      .subscribe({
        next: res => {
          const curr = this.entity?.[employeeField.property] ? employeeField.options.find(opt => opt.id === this.entity[employeeField.property]) as CustomEntity : null;
          if (curr && !res.data.some(x => x.id === curr.id)) {
            res.data.push(curr);
          }
          this.employees = res.data;
          if (this.fields) {
            if (employeeField) employeeField.options = this.employees;
          }
        }
      });
  }

  updateDimensionFields() {
    this.formFieldService.updateDimensionFields(this.entity, this.fields);
  }

  override close(data: Object = null) {
    this.eventService.broadcast(EventKeys.flyoutClose, data);
  }

  private isCustomFieldKey(key: string): boolean {
    return isCustomFieldKey(key);
  }

  openAttachmentForm() {
    this.dialog.open(AttachmentsDialogComponent, {
      data: {
        allowedFileTypes: ['jpg', 'jpeg', 'png', 'pdf'],
        maxFileSizeMB: 10,
        assetType: AssetTypeEnum.IHAttachments,
        organizationLevelId: this.entity.organizationLevelId,
      },
      width: '460px',
      panelClass: 'attachments-dialog',
      autoFocus: false
    }).afterClosed().subscribe(result => {
      if (result) {
        this.entity.fileAttachmentIds.push(result.id);
        this.attachedFiles.push(result);
        const field = this.fields.find(f => f?.property === nameOf<Sample>(x => x.fileAttachmentIds));
        if (field) { field.options = [...this.attachedFiles] }
      }
    });
  }

  onStepChanged(step: StepConfig) {
    this.currentStep = step;
    if (step.id === 'controlFields') {
      if (!this.entity.sampleTasks) {
        this.entity.sampleTasks = [];
      }
      this.initTaskData();
    }
    if (step.id === 'weatherInfo') {
      this.refreshWeatherAvailability();
    }
    this.applyPressureCorrectionChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // The weather endpoint's Admin policy accepts the Admin security profile only, so other users never see the option.
  private canUserFetchWeather(currentUser: UserIdentity | null): boolean {
    return !this.isTemplateEdit && currentUser?.userType === SecurityProfileEnum.Admin;
  }

  fetchWeather(): void {
    if (!this.canFetchWeather || this.isWeatherFetchDisabled || !this.weatherCoordinates || !this.weatherSamplingDay) return;
    const requestDate = this.weatherService.toRequestDate(this.weatherSamplingDay);
    this.setWeatherStatus(WeatherFetchStatus.Loading, null);
    this.weatherService.getDaily(this.weatherCoordinates, this.weatherSamplingDay).pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: response => this.onWeatherFetched(this.sampleWeatherService.toSampleValues(response, requestDate)),
      error: error => this.onWeatherFetchFailed(error)
    });
  }

  private async onWeatherFetched(values: SampleWeatherValues | null): Promise<void> {
    if (!values) {
      this.setWeatherStatus(WeatherFetchStatus.NoData, this.translateService.getDynamicTranslation('No weather data is available for this location and date.'));
      return;
    }
    if (this.sampleWeatherService.wouldOverwrite(this.entity, values)) {
      this.setWeatherStatus(WeatherFetchStatus.Idle, null);
      const confirmed = await this.openConfirmDialog({
        title: 'Replace weather values?',
        message: 'The fetched weather data will replace the temperature, humidity and pressure values already entered. Do you want to continue?',
        primaryButtonText: 'Replace',
        secondaryButtonText: 'Cancel'
      });
      if (!confirmed) return;
    }
    this.applyWeatherValues(values);
    const message = this.sampleWeatherService.isComplete(values)
      ? 'Weather data applied. Review the values before saving.'
      : 'Weather data applied. Values that were not available were left unchanged.';
    this.setWeatherStatus(WeatherFetchStatus.Applied, this.translateService.getDynamicTranslation(message));
  }

  private onWeatherFetchFailed(error: unknown): void {
    if (this.sampleWeatherService.isNoDataError(error)) {
      this.setWeatherStatus(WeatherFetchStatus.NoData, this.translateService.getDynamicTranslation('No weather data is available for this location and date.'));
      return;
    }
    this.setWeatherStatus(WeatherFetchStatus.Error, this.sampleWeatherService.getErrorMessage(error));
  }

  private applyWeatherValues(values: SampleWeatherValues): void {
    Object.assign(this.entity, values);
    this.entity.weatherSource = WeatherSourceType.WeatherApp;
    const appliedProperties = new Set<string>(Object.keys(values));
    (this.fields ?? [])
      .filter(field => appliedProperties.has(field.property))
      .forEach(field => this.onTemplateFieldEdited(field));
  }

  private refreshWeatherAvailability(): void {
    if (!this.canFetchWeather) return;
    this.weatherSamplingDay = this.sampleWeatherService.getSamplingDay(this.entity.startDate);
    this.weatherCoordinates = null;
    this.isWeatherLocationPending = true;
    this.setWeatherStatus(WeatherFetchStatus.Idle, null);
    this.resolveWeatherSite().pipe(takeUntil(this.destroy$)).subscribe({
      next: site => {
        this.weatherCoordinates = site?.orgLevelType === OrgLevelTypeEnum.Site
          ? this.sampleWeatherService.getCoordinates(site)
          : null;
        this.isWeatherLocationPending = false;
        this.updateWeatherAvailability();
      },
      error: () => {
        this.isWeatherLocationPending = false;
        this.updateWeatherAvailability();
      }
    });
  }

  // Weather comes from the sample's Site: a fixed physical location, unlike an employee or a mobile node.
  // GetParentSite returns the level itself when it is a Site, its Site ancestor otherwise, and null above site level.
  private resolveWeatherSite(): Observable<Partial<OrganizationLevel> | null> {
    const organizationLevelId = this.entity.organizationLevelId;
    if (!organizationLevelId) return of(null);
    return this.organizationLevelService.getParentSite(organizationLevelId);
  }

  private setWeatherStatus(status: WeatherFetchStatus, message: string | null): void {
    this.weatherFetchStatus = status;
    this.weatherMessage = message;
    this.updateWeatherAvailability();
  }

  private updateWeatherAvailability(): void {
    let unavailableReason: string | null = null;
    if (this.isWeatherLocationPending) {
      unavailableReason = 'Checking the sample location...';
    } else if (!this.weatherCoordinates) {
      unavailableReason = 'Set the latitude and longitude on the site organization level of this sample to fetch weather data.';
    } else if (!this.weatherSamplingDay) {
      unavailableReason = 'Set the date of sampling to fetch weather data.';
    }
    this.isWeatherLookupUnavailable = unavailableReason != null;
    this.weatherHint = this.translateService.getDynamicTranslation(
      unavailableReason ?? 'Uses the coordinates of the site organization level of this sample and the date of sampling.'
    );
    this.isWeatherFetchDisabled = this.isWeatherLookupUnavailable || this.isReadonly || this.weatherFetchStatus === WeatherFetchStatus.Loading;
  }

  async savePartial() {
    if (!this.validate()) return;

    if (!await this.ensureCalDriftAcknowledged()) return;

    const voidReasonPassed = await this.ensureVoidReasonIfNeeded();
    if (!voidReasonPassed) return;

    const model = JSON.parse(JSON.stringify(this.entity));
    this.onBeforeSave(model);
    this.isLoading = true;

    try {
      const response = await firstValueFrom(this.saveAction(model)) as Sample;
      this.entity.id = response.id;
      if (this.isAdd) {
        this.isAdd = false;
        this.entity.sampleNumber = response.sampleNumber;
        this.setTitle(`Sample - ${this.entity.sampleNumber}`);
        this.formFieldService.updateSampleNumberField(this.entity, this.organizationLevels, this.fields);
      }
      this.entity.sensorAssignmentId = response.sensorAssignmentId;
      this.isLoading = false;
      return true;
    } catch (error) {
      this.handleError(error);
      this.isLoading = false;
      return false;
    }
  }

  private createSampleStep(id: string, label: string, fields: any[],
    options?: Partial<{ hasNext: boolean; customButtons: any[]; customNextLabel: string; }>): any {
    const { hasNext = true, customButtons = [], customNextLabel } = options || {};

    if (this.isTemplateEdit) {
      const templateEditButtons: StepperButton[] = [
        { label: 'Save Changes', class: 'custom-main-btn', action: () => this.save(), disabled: () => !this.isTemplateDirtyState || this.isLoading },
        { label: 'Cancel', class: 'bordered-btn', action: () => this.close(true) }
      ];
      return {
        id, label, template: this.stepTpl, fields,
        visible: () => Boolean(fields.filter(field => field.isVisible(this.entity)).length),
        buttons: templateEditButtons
      };
    }

    return {
      id, label, template: this.stepTpl, fields,
      visible: () => Boolean(fields.filter(field => field.isVisible(this.entity)).length),
      buttons: [{ label: 'Save & Exit', class: 'bordered-btn', action: () => this.save() }, ...customButtons],
      ...(hasNext && {
        nextLabel: customNextLabel ?? 'Save and Continue',
        onNext: async () => {
          const isValid = await this.savePartial();
          return isValid;
        }
      })
    };
  }

  public trackById = trackById;
  public trackByIndex = trackByIndex;

  get sampleStatusName() {
    return this.sampleStatusList.find(status => status.id === this.entity.sampleStatus)?.name;
  }

  private loadTemplateForEdit(): void {
    const editData = this.data as SampleDialogTemplateEditData;
    this.sampleTemplateService.getById(editData.editSampleTemplateId).subscribe({
      next: (template) => {
        this.editingTemplate = template;
        this.entity.sampleType = template.sampleType;
        this.entity.sampleCategory = template.sampleCategory;
        if (template.settings?.organizationLevelId != null) {
          this.entity.organizationLevelId = template.settings.organizationLevelId;
        }
        this.onSampleTypeChanged();
        this.updateFlowFields();
        this.fieldChanges();
        this.applyTemplateSettings(template.settings);
        this.showStepper();
        this.templateBaseline = JSON.stringify(this.buildTemplateSettings());
      },
      error: (error) => {
        this.toastService.showError(error);
      }
    });
  }

  loadAvailableTemplates(): void {
    if (this.entity.sampleType == null || this.entity.sampleCategory == null) return;
    const filterBy = JSON.stringify({
      [nameOf<SampleTemplate>(x => x.sampleType)]: `${this.entity.sampleType}`,
      [nameOf<SampleTemplate>(x => x.sampleCategory)]: `${this.entity.sampleCategory}`
    });
    this.sampleTemplateService.getAll(filterBy).subscribe({
      next: (templates: Lookup[]) => {
        this.availableTemplates = templates.map(t => ({ id: t.id, name: t.name }));
        this.checkDefaultTemplate();
      },
      error: (error) => {
        this.toastService.showError(error);
      }
    });
  }

  private loadAllTemplatesForPicker(): void {
    const sampleTypeNames = getEnumLookup(SampleTypeEnum);
    this.sampleTemplateService.getAllWithType().subscribe({
      next: (templates) => {
        this.allTemplates = templates.map(t => ({
          ...t,
          sampleTypeName: sampleTypeNames.find(s => s.id === t.sampleType)?.name ?? ''
        }));
      },
      error: (error) => {
        this.toastService.showError(error);
      }
    });
  }

  private checkDefaultTemplate(): void {
    if (this.suppressDefaultTemplateAutoApply) return;
    this.sampleTemplateService.getDefault(this.entity.sampleType).subscribe({
      next: (defaultTemplate) => {
        if (!defaultTemplate || defaultTemplate.sampleCategory !== this.entity.sampleCategory) return;
        this.defaultTemplateName = defaultTemplate.name;
        this.isDefaultTemplateBannerVisible = true;
        const jurisdictionCleared = this.resetTemplateFilledFields();
        if (jurisdictionCleared) this.updateJurisdiction();
        this.applyTemplateSettings(defaultTemplate.settings);
        this.selectedTemplateId = defaultTemplate.id;
        this.appliedTemplate = defaultTemplate;
        this.updateSaveTemplateMode();
      },
      error: (error) => {
        this.toastService.showError(error);
      }
    });
  }

  onTemplateSelected(templateId: string | null): void {
    this.selectedTemplateId = templateId;
    if (!templateId) {
      this.templateSelectionRequestId++;
      this.clearTemplateFields();
      return;
    }
    const requestId = ++this.templateSelectionRequestId;
    this.sampleTemplateService.getById(templateId).subscribe({
      next: (template) => {
        if (requestId !== this.templateSelectionRequestId) return;
        const jurisdictionCleared = this.resetTemplateFilledFields();
        if (jurisdictionCleared) this.updateJurisdiction();
        this.applyTemplateSettings(template.settings);
        this.appliedTemplate = template;
        this.updateSaveTemplateMode();
      },
      error: (error) => {
        if (requestId !== this.templateSelectionRequestId) return;
        this.toastService.showError(error);
      }
    });
  }

  onTemplateSelectedUpFront(templateId: string | null): void {
    if (templateId == null) return;

    this.suppressDefaultTemplateAutoApply = true;
    this.sampleTemplateService.getById(templateId).subscribe({
      next: (template) => this.applyUpFrontTemplate(template),
      error: (error) => {
        this.suppressDefaultTemplateAutoApply = false;
        this.toastService.showError(error);
      }
    });
  }

  private applyUpFrontTemplate(template: SampleTemplate): void {
    this.entity.sampleType = template.sampleType;
    this.entity.sampleCategory = template.sampleCategory;
    if (template.organizationLevelId != null) this.entity.organizationLevelId = template.organizationLevelId;

    // Mirrors the Sample Type field's onChange.
    this.fieldChanges();
    this.updateFlowFields();
    this.sampleStatusList = getFilteredSampleStatuses(getEnumLookup(SampleStatusEnum), this.entity?.sampleType, this.entity?.sampleCategory, this.entity?.sampleStatus);
    this.applyDefaultEndTime();

    // Mirrors the Sample Category field's onChange.
    this.onSampleCategoryChanged();

    // Mirrors the Sampling Site field's onChange.
    this.updateUserOptions();
    this.getSiteInfo();

    // Joins updateAgentsList$ too, so agentIds never applies before the agent picker's own options load.
    forkJoin([this.updatePpe$(), this.updateSamplingEquipmentList$(), this.updateAgentsList$()]).subscribe({
      next: () => {
        this.applyTemplateSettings(template.settings);
        this.appliedTemplate = template;
        this.selectedTemplateId = template.id;
        this.updateSaveTemplateMode();
        this.showStepper();
      },
      error: (error) => {
        this.suppressDefaultTemplateAutoApply = false;
        this.toastService.showError(error);
      }
    });
  }

  private applyTemplateSettings(settings: SampleTemplateSettings | null | undefined): void {
    if (!settings) return;

    let agentsFilledFromTemplate = false;
    if (settings.segId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.segId), settings.segId);
    if (settings.labId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.labId), settings.labId);
    if (settings.analyticalMethodId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.analyticalMethodId), settings.analyticalMethodId);
    if (settings.oelTypeId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.oelTypeId), settings.oelTypeId);
    if (settings.agentIds?.length && this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.agentIds), settings.agentIds)) {
      this.useAgentGroups = false;
      this.entity.selectedBy = 0;
      this.entity.agentGroupId = null;
      agentsFilledFromTemplate = true;
    }
    if (settings.agentGroupId != null && this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.agentGroupId), settings.agentGroupId)) {
      this.useAgentGroups = true;
      this.entity.selectedBy = 1;
      this.entity.agentIds = [];
      this.getGroupAgents();
      agentsFilledFromTemplate = true;
    }
    if (settings.samplingEquipmentId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.samplingEquipmentId), settings.samplingEquipmentId);
    if (settings.calibrationEquipmentId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.calibrationEquipmentId), settings.calibrationEquipmentId);
    if (settings.sampleMediaId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.sampleMediaId), settings.sampleMediaId);
    if (settings.endPointId != null && this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.endPointId), settings.endPointId)) {
      this.entity['location'] = settings.endPointId;
      this.templateFilledFields.add('location');
      this.templateFilledFields.add('search_employee');
      this.getCustomEntities();
    }
    if (settings.organizationLevelId != null) {
      const organizationLevelIdBefore = this.entity.organizationLevelId;
      this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.organizationLevelId), settings.organizationLevelId);
      if (this.entity.organizationLevelId !== organizationLevelIdBefore) {
        this.updateUserOptions();
        this.fieldChanges();
        this.getSiteInfo();
        this.loadSegShiftValues();
      }
    }
    if (settings.unsampledTimeCorrection != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.unsampledTimeCorrection), settings.unsampledTimeCorrection);
    if (settings.applyShiftCorrection != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.applyShiftCorrection), settings.applyShiftCorrection);
    if (settings.applyPressureCorrection != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.applyPressureCorrection), settings.applyPressureCorrection);
    if (settings.shiftType != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.shiftType), settings.shiftType);
    if (settings.ppeAssignments?.length) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.ppeAssignmentList), settings.ppeAssignments);
    if (settings.managingHygienistId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.managingHygienistId), settings.managingHygienistId);
    if (settings.sampleSurveyId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.sampleSurveyId), settings.sampleSurveyId);
    if (settings.blankSampleId != null) {
      this.getBlankSamples();
      this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.blankSampleId), settings.blankSampleId);
    }
    if (settings.shiftLength != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.shiftLength), settings.shiftLength);
    if (settings.averageWeeklyHours_Seconds != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.averageWeeklyHours_Seconds), settings.averageWeeklyHours_Seconds);
    if (settings.shiftRoster != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.shiftRoster), settings.shiftRoster);
    if (settings.shiftId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.shiftId), settings.shiftId);
    if (settings.locationComments != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.locationComments), settings.locationComments);
    if (settings.wipeDimensions != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.wipeDimensions), settings.wipeDimensions);
    if (settings.exposureTypicality != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.exposureTypicality), settings.exposureTypicality);
    if (settings.summaryNote != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.summaryNote), settings.summaryNote);
    if (settings.mediaLotNumber != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.mediaLotNumber), settings.mediaLotNumber);
    if (settings.samplePreCal != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.samplePreCal), settings.samplePreCal);
    if (settings.samplePostCal != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.samplePostCal), settings.samplePostCal);
    if (settings.temperatureMaxC != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.temperatureMaxC), settings.temperatureMaxC);
    if (settings.temperatureMinC != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.temperatureMinC), settings.temperatureMinC);
    if (settings.humidityPercent != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.humidityPercent), settings.humidityPercent);
    if (settings.pressureMmhg != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.pressureMmhg), settings.pressureMmhg);
    if (settings.weatherCondition != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.weatherCondition), settings.weatherCondition);
    if (settings.sensorId != null) this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.sensorId), settings.sensorId);
    if (settings.noiseType != null && this.shouldOverrideField('noiseType')) {
      this.entity['noiseType'] = settings.noiseType;
      this.templateFilledFields.add('noiseType');
      this.configDefaultFields.delete('noiseType');
    }

    if (settings.fileAttachmentIds?.length && this.applyTemplateFieldIfEligible(nameOf<Sample>(x => x.fileAttachmentIds), settings.fileAttachmentIds)) {
      const fileAttachmentIds = settings.fileAttachmentIds;
      this.fileAttachmentService.get('', 'id', 'asc', 0, fileAttachmentIds.length, JSON.stringify({ id: fileAttachmentIds.join(',') })).subscribe({
        next: (res) => {
          this.attachedFiles = res.data;
          const field = this.fields?.find(f => f?.property === nameOf<Sample>(x => x.fileAttachmentIds));
          if (field) field.options = this.attachedFiles;
        },
        error: (error) => this.toastService.showError(error)
      });
    }

    if (settings.jurisdictionIds?.length) {
      const jurisdictionKey = nameOf<Sample>(x => x.jurisdictionIds);
      if (this.shouldOverrideField(jurisdictionKey)) {
        this.entity.jurisdictionIds = settings.jurisdictionIds;
        this.templateFilledFields.add(jurisdictionKey);
        this.configDefaultFields.delete(jurisdictionKey);
        if (!agentsFilledFromTemplate) this.updateJurisdiction();
      }
    }

    if (agentsFilledFromTemplate) {
      this.updateAgent(false, false, () => this.updateJurisdiction());
    }

    this.rebuildTemplateFieldStates();
  }

  private isFieldEmpty(key: string): boolean {
    const current = this.entity[key as keyof Sample];
    return current == null || (Array.isArray(current) && (current as unknown[]).length === 0);
  }

  private shouldOverrideField(key: string): boolean {
    if (this.segLockedFields.has(key)) return false;
    return this.isFieldEmpty(key) || this.configDefaultFields.has(key);
  }

  private applyTemplateFieldIfEligible<K extends keyof Sample>(key: K, value: Sample[K] | null | undefined): boolean {
    if (value == null || !this.shouldOverrideField(key as string)) return false;
    this.entity[key] = value;
    this.templateFilledFields.add(key as string);
    this.configDefaultFields.delete(key as string);
    return true;
  }

  onTemplateFieldEdited(field: FormField): void {
    const property = field?.property;
    if (!property) return;
    this.configDefaultFields.delete(property);
    this.segLockedFields.delete(property);
    if (this.templateFilledFields.has(property) && !this.templateEditedFields.has(property)) {
      this.templateEditedFields.add(property);
      this.rebuildTemplateFieldStates();
    }
    if (this.isTemplateEdit) this.isTemplateDirtyState = this.isTemplateDirty();
  }

  private rebuildTemplateFieldStates(): void {
    const states = new Map<string, TemplateFieldState>();
    this.templateFilledFields.forEach(property => {
      states.set(property, this.templateEditedFields.has(property) ? 'edited' : 'from-template');
    });
    this.templateFieldStates = states;
  }

  private resetFieldToConfigDefaultOrNull<K extends keyof Sample>(key: K): void {
    if (this.configDefaultValues.has(key as string)) {
      this.entity[key] = structuredClone(this.configDefaultValues.get(key as string)) as Sample[K];
      this.configDefaultFields.add(key as string);
      return;
    }
    const current = this.entity[key];
    this.entity[key] = (Array.isArray(current) ? [] : null) as Sample[K];
  }

  private resetTemplateFilledFields(): boolean {
    const jurisdictionKey = nameOf<Sample>(x => x.jurisdictionIds);
    let jurisdictionCleared = false;

    [...this.templateFilledFields].forEach(key => {
      if (this.templateEditedFields.has(key)) return;
      this.resetFieldToConfigDefaultOrNull(key as keyof Sample);
      this.templateFilledFields.delete(key);
      if (key === jurisdictionKey) jurisdictionCleared = true;
    });

    return jurisdictionCleared;
  }

  private isSegEligible(key: string): boolean {
    if (this.segLockedFields.has(key)) return true;
    if (this.isFieldEmpty(key) || this.configDefaultFields.has(key)) return true;
    return this.templateFilledFields.has(key) && !this.templateEditedFields.has(key);
  }

  private releaseSegLock<K extends keyof Sample>(key: K): void {
    if (!this.segLockedFields.has(key as string)) return;
    this.segLockedFields.delete(key as string);
    this.resetFieldToConfigDefaultOrNull(key);
    const templateValue = this.appliedTemplate?.settings?.[key as keyof SampleTemplateSettings] as Sample[K] | null | undefined;
    this.applyTemplateFieldIfEligible(key, templateValue);
  }

  private applySegField<K extends keyof Sample>(key: K, segValue: Sample[K] | null | undefined): void {
    if (segValue == null) {
      this.releaseSegLock(key);
      return;
    }
    if (!this.isSegEligible(key as string)) return;
    this.entity[key] = segValue;
    this.segLockedFields.add(key as string);
    this.templateFilledFields.delete(key as string);
    this.templateEditedFields.delete(key as string);
    this.configDefaultFields.delete(key as string);
  }

  private applySegShiftValues(segValues: SegShiftValues | null): void {
    this.applySegField(nameOf<Sample>(x => x.shiftLength), segValues?.shiftLength);
    this.applySegField(nameOf<Sample>(x => x.averageWeeklyHours_Seconds), segValues?.averageWeeklyHours_Seconds);
    this.applySegField(nameOf<Sample>(x => x.shiftRoster), segValues?.shiftRoster);
    this.rebuildTemplateFieldStates();
  }

  private loadSegShiftValues(): void {
    this.agentJurisdictionLoaderService.getSegOrgs(this.entity).subscribe({ next: segValues => this.applySegShiftValues(segValues) });
  }

  clearTemplateFields(): void {
    const jurisdictionCleared = this.resetTemplateFilledFields();

    this.templateFilledFields.clear();
    this.templateEditedFields.clear();
    this.templateFieldStates = new Map<string, TemplateFieldState>();
    this.selectedTemplateId = null;
    this.defaultTemplateName = null;
    this.isDefaultTemplateBannerVisible = false;
    this.appliedTemplate = null;
    this.updateSaveTemplateMode();

    if (jurisdictionCleared) this.updateJurisdiction();
  }

  private updateSaveTemplateMode(): void {
    this.saveTemplateMode = !this.appliedTemplate
      ? SaveTemplateMode.Create
      : this.appliedTemplate.canManage
        ? SaveTemplateMode.Update
        : SaveTemplateMode.ConfirmSaveAsNew;
    this.saveTemplateLabel = SAVE_TEMPLATE_MODE_LABELS[this.saveTemplateMode];
  }

  onSaveTemplateClick(): void {
    if (this.isSavingTemplate) return;
    this.isSavingTemplate = true;
    switch (this.saveTemplateMode) {
      case SaveTemplateMode.Update:
        this.updateAppliedTemplate();
        return;
      case SaveTemplateMode.ConfirmSaveAsNew:
        this.confirmSaveAppliedTemplateAsNew();
        return;
      default:
        this.openSaveAsTemplateDialog();
    }
  }

  private updateAppliedTemplate(): void {
    if (!this.appliedTemplate) {
      this.isSavingTemplate = false;
      return;
    }
    const updatedTemplate: SampleTemplate = { ...this.appliedTemplate, settings: this.buildTemplateSettings() };
    this.sampleTemplateService.update(updatedTemplate).pipe(
      finalize(() => { this.isSavingTemplate = false; })
    ).subscribe({
      next: () => {
        this.appliedTemplate = updatedTemplate;
        this.templateEditedFields.clear();
        this.rebuildTemplateFieldStates();
        this.updateSaveTemplateMode();
        this.toastService.showSuccess('Template updated successfully', true);
      },
      error: (error) => {
        this.toastService.showError(error);
      }
    });
  }

  private async confirmSaveAppliedTemplateAsNew(): Promise<void> {
    const confirmed = await this.openConfirmDialog({
      title: 'Save as New Template',
      message: "You can't update this template because you don't own it. Save your changes as a new template instead?",
      primaryButtonText: 'Save as new',
      secondaryButtonText: 'Cancel'
    });
    if (confirmed) {
      this.openSaveAsTemplateDialog();
    } else {
      this.isSavingTemplate = false;
    }
  }

  openSaveAsTemplateDialog(): void {
    const sampleType = this.entity.sampleType;
    const data: TemplateSaveDialogData = { dataOrganizationLevelId: this.entity.organizationLevelId ?? null };
    const dialogRef = this.dialog.open(TemplateSaveDialogComponent, {
      data,
      width: '440px',
      disableClose: true
    });

    dialogRef.afterClosed().pipe(
      filter((result): result is TemplateSaveDialogResult => !!result),
      switchMap((result) => {
        const payload: CreatePayload<SampleTemplate> = {
          name: result.name,
          sampleType,
          sampleCategory: this.entity.sampleCategory,
          isShared: result.isShared,
          isDefault: false,
          organizationLevelId: result.organizationLevelId ?? this.entity.organizationLevelId,
          canManage: true,
          settings: this.buildTemplateSettings()
        };
        return this.sampleTemplateService.create(payload);
      }),
      finalize(() => { this.isSavingTemplate = false; })
    ).subscribe({
      next: () => {
        this.toastService.showSuccess('Template saved successfully', true);
      },
      error: (error) => {
        this.toastService.showError(error);
      }
    });
  }

  private buildTemplateSettings(): SampleTemplateSettings {
    const e = this.entity;
    return {
      segId: e.segId ?? null,
      jurisdictionIds: e.jurisdictionIds?.length ? [...e.jurisdictionIds] : null,
      oelTypeId: e.oelTypeId ?? null,
      labId: e.labId ?? null,
      analyticalMethodId: e.analyticalMethodId ?? null,
      agentIds: e.agentIds?.length ? [...e.agentIds] : null,
      agentGroupId: e.agentGroupId ?? null,
      samplingEquipmentId: e.samplingEquipmentId ?? null,
      calibrationEquipmentId: e.calibrationEquipmentId ?? null,
      sampleMediaId: e.sampleMediaId ?? null,
      endPointId: e.endPointId ?? null,
      organizationLevelId: e.organizationLevelId ?? null,
      unsampledTimeCorrection: e.unsampledTimeCorrection ?? null,
      applyShiftCorrection: e.applyShiftCorrection ?? null,
      applyPressureCorrection: e.applyPressureCorrection ?? null,
      shiftType: e.shiftType ?? null,
      ppeAssignments: e.ppeAssignmentList?.length ? [...e.ppeAssignmentList] : null,
      managingHygienistId: e.managingHygienistId ?? null,
      sampleSurveyId: e.sampleSurveyId ?? null,
      shiftLength: this.segLockedFields.has(nameOf<Sample>(x => x.shiftLength)) ? null : (e.shiftLength ?? null),
      averageWeeklyHours_Seconds: this.segLockedFields.has(nameOf<Sample>(x => x.averageWeeklyHours_Seconds)) ? null : (e.averageWeeklyHours_Seconds ?? null),
      shiftRoster: this.segLockedFields.has(nameOf<Sample>(x => x.shiftRoster)) ? null : (e.shiftRoster ?? null),
      shiftId: e.shiftId ?? null,
      locationComments: e.locationComments ?? null,
      wipeDimensions: e.wipeDimensions ?? null,
      exposureTypicality: e.exposureTypicality ?? null,
      summaryNote: e.summaryNote ?? null,
      mediaLotNumber: e.mediaLotNumber ?? null,
      samplePreCal: e.samplePreCal ?? null,
      samplePostCal: e.samplePostCal ?? null,
      temperatureMaxC: e.temperatureMaxC ?? null,
      temperatureMinC: e.temperatureMinC ?? null,
      humidityPercent: e.humidityPercent ?? null,
      pressureMmhg: e.pressureMmhg ?? null,
      weatherCondition: e.weatherCondition ?? null,
      blankSampleId: e.blankSampleId ?? null,
      fileAttachmentIds: e.fileAttachmentIds?.length ? [...e.fileAttachmentIds] : null,
      sensorId: e.sensorId ?? null,
      noiseType: e['noiseType'] ?? null
    };
  }
}
